<template>
	<div>
		<v-container v-if="primaryView" class="full-height order">
		<v-alert
			v-if="$store.getters['ezeepHealth/ezeepHasIssues']"
			:type="$store.getters['ezeepHealth/ezeepStatus'] === 'error' ? 'error' : 'warning'"
			text
			dense
			dismissible
			class="mb-2"
		>
			<strong>Printer Issue:</strong> {{ $store.getters['ezeepHealth/ezeepStatusMessage'] }}.
			Auto-print may not work.
			<router-link v-if="canViewPrinterSettings" to="/settings/printers" class="ml-1">View Printers</router-link>
		</v-alert>
		<v-row id="detail-container">
			<v-col cols="12" class="flex-none">
				<div class="order-form">
					<div class="order-header-wrapper">
						<v-row>
							<v-col class="order-form-header">
								<h1 class="order-form-title">
									{{ orderData.organization }}
								</h1>
								<div class="order-form-status" :class="renderStatusColor(orderData.status)">
									{{ renderStatus(orderData.status).label }}
								</div>
								<v-chip
									v-if="hasSampleItems"
									small
									color="#1565c0"
									text-color="white"
									class="ml-2"
								>
									Sample
								</v-chip>
							</v-col>
							<v-col>
								<div class="order-actions">
									<v-tooltip bottom :disabled="orderData.processDate != ''">
										<template v-slot:activator="{ on }">
											<span v-on="on" class="order-action-wrapper">
												<v-btn
													depressed
													outlined
													:disabled="orderData.processDate == ''"
													@click="$router.push(`${basePath}/${orderData.salesOrderId}/status`)"
												>Order Status</v-btn>
											</span>
										</template>
										<span>Order has not been processed yet.</span>
									</v-tooltip>
									<v-tooltip bottom v-if="!canUpdate">
										<template v-slot:activator="{ on }">
											<span v-on="on" class="order-action-wrapper">
												<v-btn
													depressed
													outlined
													:disabled="true"
												>Save</v-btn>
											</span>
										</template>
										<span>You do not have permission to update this order.</span>
									</v-tooltip>
									<v-btn
										v-else
										depressed
										outlined
										:loading="isSaving"
										:disabled="isSaving"
										@click="trySave()"
										>Save</v-btn
									>
									<v-menu offset-y left nudge-bottom="4" content-class="order-overflow-menu">
										<template v-slot:activator="{ on, attrs }">
											<v-btn depressed outlined class="kebab-btn" v-bind="attrs" v-on="on">
												<v-icon>mdi-dots-vertical</v-icon>
											</v-btn>
										</template>
										<v-list>
											<v-list-item
																								@click="
													printType = 'INVOICE';
													$router.push(`${basePath}/${orderData.salesOrderId}/print`);
												"
											>
												<v-list-item-icon><v-icon>mdi-printer-outline</v-icon></v-list-item-icon>
												<v-list-item-title>Print</v-list-item-title>
											</v-list-item>
											<v-list-item
												v-if="canUsePayments()"
																								@click="$router.push(`${basePath}/${orderData.salesOrderId}/payments`)"
											>
												<v-list-item-icon><v-icon>mdi-credit-card-outline</v-icon></v-list-item-icon>
												<v-list-item-title>Payments</v-list-item-title>
											</v-list-item>
											<v-divider></v-divider>
											<v-list-item
																								@click="showCloneDialog = true"
											>
												<v-list-item-icon><v-icon>mdi-content-copy</v-icon></v-list-item-icon>
												<v-list-item-title>Duplicate</v-list-item-title>
											</v-list-item>
											<v-list-item
												@click="showAuditHistory = true"
											>
												<v-list-item-icon><v-icon>mdi-history</v-icon></v-list-item-icon>
												<v-list-item-title>Audit History</v-list-item-title>
											</v-list-item>
											<v-list-item
												v-if="canRestoreLineItems"
												@click="showRestoreDialog = true"
											>
												<v-list-item-icon><v-icon>mdi-restore</v-icon></v-list-item-icon>
												<v-list-item-title>Restore Line Items</v-list-item-title>
											</v-list-item>
											<v-list-item
												v-if="canRepairPoNumbers"
												@click="showPoRepairDialog = true"
											>
												<v-list-item-icon><v-icon>mdi-auto-fix</v-icon></v-list-item-icon>
												<v-list-item-title>Repair PO Numbers</v-list-item-title>
											</v-list-item>
											<v-divider></v-divider>
											<v-list-item
																								@click="$router.push({ path: basePath })"
											>
												<v-list-item-icon><v-icon>mdi-arrow-left</v-icon></v-list-item-icon>
												<v-list-item-title>Close</v-list-item-title>
											</v-list-item>
										</v-list>
									</v-menu>
								</div>
								<v-dialog v-model="showCloneDialog" max-width="400px">
									<v-card>
										<v-card-title class="headline"> Clone Order to Quote </v-card-title>

										<v-card-text>
											<p class="mb-4">Select which elements to include in the cloned quote:</p>

											<v-checkbox
												v-model="cloneOptions.copySizes"
												label="Copy Size Selections"
												hide-details
												class="mb-2"
											></v-checkbox>

											<v-checkbox
												v-model="cloneOptions.copySpecialSizes"
												label="Copy Special Size Selections"
												hide-details
												class="mb-2"
											></v-checkbox>

											<v-checkbox
												v-model="cloneOptions.copyColors"
												label="Copy Color Selections"
												hide-details
												class="mb-2"
											></v-checkbox>

											<v-checkbox
												v-model="cloneOptions.copyNotes"
												label="Copy Line Item Notes"
												hide-details
												class="mb-4"
											></v-checkbox>

											<v-alert
												v-if="!cloneOptions.copySizes || !cloneOptions.copyColors"
												type="warning"
												text
												dense
												class="mb-0"
											>
												Unchecked selections will need to be re-entered in the new quote.
											</v-alert>
										</v-card-text>

										<v-card-actions>
											<v-spacer></v-spacer>
											<v-btn text @click="showCloneDialog = false"> Cancel </v-btn>
											<v-btn color="primary" @click="handleCloneToQuote" :loading="cloneLoading">
												Create Quote
											</v-btn>
										</v-card-actions>
									</v-card>
								</v-dialog>
									<v-dialog v-model="showRestoreDialog" max-width="600px" persistent>
										<v-card>
											<v-card-title style="font-size: 1.6rem; word-break: normal">
												Restore Line Items
												<v-spacer></v-spacer>
												<v-btn icon small @click="showRestoreDialog = false" :disabled="isRestoring">
													<v-icon small>mdi-close</v-icon>
												</v-btn>
											</v-card-title>
											<v-card-text style="font-size: 1.4rem;">
												<v-alert type="warning" text class="mb-4">
													This is a recovery action for orders that lost their line items due to a system error.
												</v-alert>
												<p class="mb-2" style="font-size: 1.4rem;">This will perform the following:</p>
												<ul class="mb-4" style="padding-left: 2rem; font-size: 1.4rem;">
													<li>Delete all existing purchase orders for this order</li>
													<li>Delete all received inventory records</li>
													<li>Delete all pick tickets and shipping labels</li>
													<li>Restore line items from the original quote</li>
													<li>Re-trigger order processing to regenerate POs</li>
												</ul>
												<v-alert type="error" text class="mb-0">
													All shipping labels and tracking numbers for this order will be lost. This action cannot be undone.
												</v-alert>
											</v-card-text>
											<v-card-actions class="pa-4">
												<v-spacer></v-spacer>
												<v-btn depressed outlined @click="showRestoreDialog = false" :disabled="isRestoring">Cancel</v-btn>
												<v-btn color="error" depressed @click="confirmRestoreOrderLineItems" :loading="isRestoring">
													Restore Line Items
												</v-btn>
											</v-card-actions>
										</v-card>
									</v-dialog>
									<v-dialog v-model="showPoRepairDialog" max-width="640px" persistent>
										<v-card>
											<v-card-title style="font-size: 1.6rem; word-break: normal">
												Repair PO Numbers
												<v-spacer></v-spacer>
												<v-btn icon small @click="showPoRepairDialog = false" :disabled="isRepairingPoNumbers">
													<v-icon small>mdi-close</v-icon>
												</v-btn>
											</v-card-title>
											<v-card-text style="font-size: 1.4rem;">
												<v-alert type="warning" text class="mb-4">
													Some purchase orders on this order were numbered with the wrong line number.
													This will rename them to match their line item and recompute the order's line numbering.
												</v-alert>
												<v-simple-table dense class="mb-4">
													<template v-slot:default>
														<thead>
															<tr>
																<th style="font-size: 1.2rem;">Current PO #</th>
																<th style="font-size: 1.2rem;"></th>
																<th style="font-size: 1.2rem;">Corrected PO #</th>
															</tr>
														</thead>
														<tbody>
															<tr v-for="change in poRepairChanges" :key="change.purchaseOrderId">
																<td style="font-size: 1.4rem;">{{ change.currentNumber }}</td>
																<td><v-icon small>mdi-arrow-right</v-icon></td>
																<td style="font-size: 1.4rem;">{{ change.correctedNumber }}</td>
															</tr>
														</tbody>
													</template>
												</v-simple-table>
												<v-alert type="info" text dense class="mb-0">
													Previously printed POs will show the corrected number when reprinted.
												</v-alert>
											</v-card-text>
											<v-card-actions class="pa-4">
												<v-spacer></v-spacer>
												<v-btn depressed outlined @click="showPoRepairDialog = false" :disabled="isRepairingPoNumbers">Cancel</v-btn>
												<v-btn color="primary" depressed @click="confirmRepairPoNumbers" :loading="isRepairingPoNumbers">
													Repair PO Numbers
												</v-btn>
											</v-card-actions>
										</v-card>
									</v-dialog>
							</v-col>
						</v-row>
					</div>

					<v-row>
						<v-col cols="4">
							<div class="form-input">
								<label>Contact</label>
								<v-select
									v-model="orderData.contactId"
									:items="contacts"
									item-text="firstName"
									item-value="contactId"
									dense
									outlined
									hide-details="auto"
									data-field="contact-select"
								>
									<template v-slot:selection="{ item }">
										<v-row no-gutters align="center">
											<span>{{ `${item.firstName} ${item.lastName}` }}</span>
										</v-row>
									</template>
									<template v-slot:item="{ item, attrs, on }">
										<v-list-item v-on="on" v-bind="attrs">
											<v-list-item-content>
												<v-list-item-title>
													<v-row no-gutters align="center">
														<span>{{ `${item.firstName} ${item.lastName}` }}</span>
													</v-row>
												</v-list-item-title>
											</v-list-item-content>
										</v-list-item>
									</template>
								</v-select>
							</div>
						</v-col>

						<v-col>
							<div class="form-input">
								<label>Customer #</label>
								<v-text-field
									outlined
									dense
									hide-details="auto"
									v-model="orderData.customerNumber"
								></v-text-field>
							</div>
						</v-col>

						<v-col>
							<div class="form-input">
								<label>Quote #</label>
								<v-text-field
									outlined
									dense
									hide-details="auto"
									v-model="orderData.quoteNumber"
									disabled
								>
									<template v-if="orderData?.quote?.quoteId" v-slot:append-outer>
										<v-tooltip bottom>
											<template v-slot:activator="{ on }">
												<router-link
													:to="{
														path: `/sales-orders/quotes/${orderData?.quote?.quoteId}`,
													}"
													><v-icon class="to-quote" v-on="on">
														mdi-open-in-new
													</v-icon></router-link
												>
											</template>
											Go to Quote
										</v-tooltip>
									</template>
								</v-text-field>
							</div>
						</v-col>

						<v-col>
							<div class="form-input">
								<label>Order #</label>
								<v-text-field
									outlined
									dense
									hide-details="auto"
									v-model="orderData.orderNumber"
									disabled
								></v-text-field>
							</div>
						</v-col>

						<v-col>
							<div class="form-input">
								<label>School PO #</label>
								<v-text-field
									outlined
									dense
									hide-details="auto"
									v-model="orderData.schoolPo"
								></v-text-field>
							</div>
						</v-col>
					</v-row>

					<v-row>
						<v-col cols="4">
							<div class="form-input">
								<label>Bill To
									<router-link v-if="orderData.customerId"
										:to="{ path: `/relationships/customer/${orderData.customerId}`, query: { addressTab: 'true', initToNewCustomerView: 'true', orderId: orderData.salesOrderId } }">
										<v-icon small class="ml-1">mdi-open-in-new</v-icon>
									</router-link>
								</label>
								<v-select
									v-model="orderData.billToId"
									:items="computedBillToAddr"
									item-value="addressId"
									dense
									outlined
									hide-details="auto"
								>
									<template v-slot:selection="{ item }">
										<span class="text-truncate d-inline-block" style="max-width: 100%">{{ item.text }}</span>
									</template>
									<template v-slot:item="{ item, on, attrs }">
										<v-list-item v-bind="attrs" v-on="on" class="address-dropdown-item">
											<v-list-item-content>
												<v-list-item-title v-if="item.contact" class="font-weight-bold">
													{{ item.contact.firstName }} {{ item.contact.lastName }}
												</v-list-item-title>
												<div v-if="item.organization" style="font-size: 1.4rem">{{ item.organization }}</div>
												<div v-if="item.department" style="font-size: 1.4rem">{{ item.department }}</div>
												<div style="font-size: 1.4rem">{{ renderAddress(item) }}</div>
												<div v-if="item.lastUsed" style="font-size: 1.2rem; color: grey">
													Last used: {{ formatDate(item.lastUsed) }}
												</div>
											</v-list-item-content>
										</v-list-item>
									</template>
								</v-select>
							</div>
						</v-col>

						<v-col cols="2">
							<div class="form-input">
								<label>Order Date</label>
								<v-menu
									v-model="showOrderDate"
									:close-on-content-click="false"
									transition="scale-transition"
									offset-y
									min-width="290px"
								>
									<template v-slot:activator="{ on, attrs }">
										<v-text-field
											v-model="formattedOrderDate"
											append-icon="mdi-calendar"
											@click:append="showOrderDate = true"
											outlined
											dense
											v-bind="attrs"
											v-on="on"
											@blur="orderData.orderDate = parseDate(formattedOrderDate)"
											hide-details="auto"
										></v-text-field>
									</template>
									<v-date-picker
										v-model="orderData.orderDate"
										@input="showOrderDate = false"
									></v-date-picker>
								</v-menu>
							</div>
						</v-col>

						<v-col cols="2">
							<div class="form-input">
								<label>Ref #</label>
								<v-text-field
									outlined
									dense
									hide-details="auto"
									v-model="orderData.referenceNumber"
								></v-text-field>
							</div>
						</v-col>

						<v-col cols="2">
							<div class="form-input">
								<label>Attribution</label>
								<v-select
									v-model="orderData.attribution"
									:items="attribuitions"
									item-text="text"
									item-value="text"
									dense
									outlined
									hide-detail
								></v-select>
							</div>
						</v-col>

						<v-col cols="2">
							<div class="form-input">
								<label>Payment Terms</label>
								<v-select
									v-model="orderData.paymentTermsId"
									:items="paymentTerms"
									item-text="paymentTermsName"
									item-value="paymentTermsId"
									dense
									outlined
									hide-detail
									data-field="payment-terms-select"
								></v-select>
							</div>
						</v-col>

						<v-col cols="4">
							<div class="form-input">
								<label>Ship To
									<router-link v-if="orderData.customerId"
										:to="{ path: `/relationships/customer/${orderData.customerId}`, query: { addressTab: 'true', initToNewCustomerView: 'true', orderId: orderData.salesOrderId } }">
										<v-icon small class="ml-1">mdi-open-in-new</v-icon>
									</router-link>
								</label>
								<v-select
									v-model="orderData.shipToId"
									:items="computedShipToAddr"
									item-value="addressId"
									dense
									outlined
									hide-details="auto"
								>
									<template v-slot:selection="{ item }">
										<span class="text-truncate d-inline-block" style="max-width: 100%">{{ item.text }}</span>
									</template>
									<template v-slot:item="{ item, on, attrs }">
										<v-list-item v-bind="attrs" v-on="on" class="address-dropdown-item">
											<v-list-item-content>
												<v-list-item-title v-if="item.contact" class="font-weight-bold">
													{{ item.contact.firstName }} {{ item.contact.lastName }}
												</v-list-item-title>
												<div v-if="item.organization" style="font-size: 1.4rem">{{ item.organization }}</div>
												<div v-if="item.department" style="font-size: 1.4rem">{{ item.department }}</div>
												<div style="font-size: 1.4rem">{{ renderAddress(item) }}</div>
												<div v-if="item.lastUsed" style="font-size: 1.2rem; color: grey">
													Last used: {{ formatDate(item.lastUsed) }}
												</div>
											</v-list-item-content>
										</v-list-item>
									</template>
								</v-select>
							</div>
						</v-col>

						<v-col cols="4">
							<div class="form-input">
								<label>Sales Rep</label>
								<v-select
									v-model="orderData.salesRepId"
									:items="salesReps"
									item-text="name"
									item-value="salesRepId"
									:item-disabled="(item) => item.inactiveDate"
									dense
									outlined
									hide-detail
									@change="saveErrors.salesRepId = undefined"
									:disabled="!canUpdate"
									data-field="sales-rep-select"
								>
									<template v-slot:item="{ item }">
										<v-list-item-content>
											<v-list-item-title :class="{ 'text--disabled': item.inactiveDate }">
												<v-row no-gutters align="center">
													<span>{{ item.name }}</span>
													<v-icon v-if="item.inactiveDate" small color="grey" class="ml-2">
														mdi-account-off
													</v-icon>
												</v-row>
											</v-list-item-title>
										</v-list-item-content>
									</template>
									<template v-slot:selection="{ item }">
										<v-row no-gutters align="center">
											<span :class="{ 'text--disabled': item.inactiveDate }">{{ item.name }}</span>
											<v-icon v-if="item.inactiveDate" small color="grey" class="ml-2">
												mdi-account-off
											</v-icon>
										</v-row>
									</template>
								</v-select>
							</div>
						</v-col>

						<v-col cols="2">
							<div class="form-input">
								<label>Shipping Method</label>
								<v-select
									v-model="orderData.shippingMethodId"
									:items="shippingMethods"
									item-text="shippingMethodName"
									item-value="shippingMethodId"
									dense
									outlined
									hide-details="auto"
									@change="onShippingMethodChange"
									data-field="shipping-method-select"
								></v-select>
							</div>
						</v-col>

						<v-col cols="2">
							<div class="form-input">
								<label>Sales Tax ID</label>
								<v-select
									v-model="orderData.salesTaxId"
									:items="taxTypes"
									item-text="text"
									item-value="salesTaxId"
									dense
									outlined
									hide-detail
								></v-select>
							</div>
						</v-col>
					</v-row>
				</div>
			</v-col>
		</v-row>

		<v-row id="sales-entry-table-container">
			<v-col cols="12" class="flex-auto">
				<SalesEntryTable
					:loading="loadingTableData"
					v-model="orderData.items"
					:maxHeight="computedTableHeight"
					@input="updateOrderItems($event)"
					@onSave="handleSave"
				/>
			</v-col>
		</v-row>

		<v-row id="sales-footer-container">
			<v-col cols="12" class="flex-none">
				<div class="order-notes">
					<div class="order-notes-heading">
						<h2>Order Notes</h2>
						<template v-if="showNoteDropdown">
							<v-btn :disabled="!canUseNotes()" depressed outlined @click="showNoteDropdown = false"
								>Cancel</v-btn
							>
							<v-btn :disabled="!canUseNotes()" depressed outlined @click="saveNote()">Save</v-btn>
						</template>
						<v-btn v-else :disabled="!canUseNotes()" depressed outlined @click="newNote()"
							>New</v-btn
						>
					</div>
					<div
						class="order-notes-dropdown"
						:class="showNoteDropdown ? 'order-notes-dropdown-active' : null"
					>
						<div class="form-textarea">
							<label>Note</label>
							<v-textarea
								outlined
								hide-details="auto"
								rows="14"
								v-model="noteData.text"
								height="16rem"
							></v-textarea>
						</div>
						<div class="order-notes-dropdown-author">
							<h3>Added By:</h3>
							<p>{{ noteData.createdBy }}</p>
						</div>
					</div>
					<div class="order-notes-container">
						<div class="order-notes-container-list">
							<div
								v-for="note in orderData.notes"
								:key="note.noteId"
								class="order-notes-container-note"
							>
								<span
									class="order-notes-container-note-type"
									:class="note.noteType == 'USER' ? 'order-notes-container-note-type-2' : null"
									>{{ note.noteType == "USER" ? "User Note" : "System Note" }}</span
								>
								<p>{{ note.text }}</p>
								<div class="order-notes-container-note-author">
									{{ formatDateLocal(note.noteDate) }} - {{ note.createdByUser }}
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="order-pricing">
					<v-row>
						<v-col
							><div class="form-input">
								<label>Payments:</label>
								<v-text-field
									class="number-input price-input"
									prepend-inner-icon="mdi-currency-usd"
									flat
									solo
									dense
									hide-details="auto"
									readonly
									:value="computedPayments"
								></v-text-field>
							</div>
							<div class="form-input">
								<label>Balance:</label>
								<v-text-field
									class="number-input price-input"
									prepend-inner-icon="mdi-currency-usd"
									flat
									solo
									dense
									hide-details="auto"
									readonly
									:value="computedBalance"
								></v-text-field></div
						></v-col>
						<v-col
							><div class="form-input">
								<label>Subtotal:</label>
								<v-text-field
									class="number-input price-input"
									prepend-inner-icon="mdi-currency-usd"
									flat
									solo
									dense
									hide-details="auto"
									readonly
									:value="computedSubtotal"
								></v-text-field>
							</div>
							<div class="form-input" data-field="shipping-handling">
								<label>
									<v-btn
										v-if="!shippingAndHandlingLocked && (shippingAndHandlingManualOverride || isShippingAndHandlingFrozen)"
										small
										text
										color="primary"
										@click="calculateShippingAndHandling(true)"
										class="ml-2"
										style="min-width: auto"
										title="Recalculate S&H"
										data-testid="recalculate-shipping-handling"
									>
										<v-icon small>mdi-refresh</v-icon>
									</v-btn>
									<v-tooltip v-if="shippingAndHandlingLocked" bottom>
										<template v-slot:activator="{ on, attrs }">
											<v-icon
												small
												class="mr-1"
												v-bind="attrs"
												v-on="on"
												data-testid="shipping-handling-locked"
											>mdi-lock</v-icon>
										</template>
										<span>{{ shippingAndHandlingLockedMessage }}</span>
									</v-tooltip>
									S&amp;H:
								</label>
								<currency-text-field
									:value="orderData.shippingAndHandling"
									@input="onShippingAndHandlingInput"
									:disabled="shippingAndHandlingLocked"
									:is-manual-override="shippingAndHandlingManualOverride"
									:tooltip="shippingAndHandlingTooltip"
								/>
							</div>
							<div class="form-input" data-field="shipping-handling-discount">
								<label>S&amp;H Discount:</label>
								<currency-text-field
									v-model="orderData.shippingAndHandlingDiscount"
									:treatAsCredit="true"
									:disabled="shippingAndHandlingLocked"
								/>
							</div>
							<div class="form-input">
								<label>Tax Rate:</label>
								<v-text-field
									class="number-input price-input tax-rate-input"
									flat
									solo
									dense
									hide-details="auto"
									append-icon="mdi-percent"
									:readonly="!taxRateEditMode"
									:value="computedTaxRate"
									@input="onTaxRateInput"
									:title="taxRateManualOverride ? 'Manually overridden - Click refresh to recalculate' : ''"
									:class="{ 'manual-override': taxRateManualOverride }"
								>
									<template v-slot:prepend-inner v-if="canAdjustTaxRate()">
										<v-icon
											v-if="!taxRateManualOverride"
											small
											class="tax-rate-edit-icon"
											@click="enableTaxRateEdit"
											title="Click to manually override tax rate"
										>mdi-pencil</v-icon>
										<v-icon
											v-else
											small
											color="primary"
											class="tax-rate-edit-icon"
											@click="resetTaxRateOverride"
											title="Recalculate Tax Rate from ZIP"
										>mdi-refresh</v-icon>
									</template>
								</v-text-field>
							</div>
							<div class="form-input">
								<label>Tax Amount:</label>
								<v-text-field
									class="number-input price-input"
									prepend-inner-icon="mdi-currency-usd"
									flat
									solo
									dense
									hide-details="auto"
									readonly
									:value="
										orderData.salesTaxId === 0
											? 0
											: ((computedSubtotal * computedTaxRate) / 100).toFixed(2)
									"
								></v-text-field>
							</div>
							<div class="form-input">
								<label>Order Total:</label>
								<v-text-field
									class="number-input price-input"
									prepend-inner-icon="mdi-currency-usd"
									flat
									solo
									dense
									hide-details="auto"
									readonly
									:value="computedOrdertotal"
								></v-text-field>
							</div>
						</v-col>
					</v-row>

					<div class="order-actions mt-4">
						<p v-if="processConfirmation" class="pr-2">Order Procesed!</p>
						<p v-if="processError" class="pr-2">Order Failed to Process!</p>
						<v-tooltip bottom v-if="!canUpdate">
							<template v-slot:activator="{ on }">
								<span v-on="on">
									<v-btn
										depressed
										outlined
										:disabled="true"
									>Save</v-btn>
								</span>
							</template>
							<span>You do not have permission to update this order.</span>
						</v-tooltip>
						<v-btn
							v-else
							depressed
							outlined
							:loading="isSaving"
							:disabled="isSaving"
							@click="trySave()"
						>Save</v-btn>
					</div>
				</div>
			</v-col>
		</v-row>

		<v-dialog v-if="confirmDialog" v-model="confirmDialog" persistent width="700">
			<v-card>
				<v-card-title style="font-size: 1.6rem; word-break: normal; padding-bottom: 4px;">
					<v-icon style="margin-right: 8px;" color="orange darken-2">mdi-alert-circle-outline</v-icon>
					Review Order Changes
					<v-spacer></v-spacer>
					<v-btn icon small @click="confirmDialog = false">
						<v-icon small>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text style="padding-top: 8px; max-height: 60vh; overflow-y: auto;">
					<p style="font-size: 1.3rem; color: #555; margin-bottom: 20px; padding-bottom: 4px; line-height: 1.5;">
						This order has already been processed. The following actions will occur when you save.
					</p>

					<!-- Shipped lines cannot be changed — the save is blocked until they are unshipped -->
					<div v-if="blockedLines.length > 0"
						style="border: 1px solid #ef9a9a; border-radius: 4px; overflow: hidden; margin-bottom: 12px;">
						<div style="padding: 10px 14px; background: #ffebee; border-bottom: 1px solid #ef9a9a; display: flex; align-items: center; gap: 8px;">
							<v-icon small color="red darken-2">mdi-cancel</v-icon>
							<span style="font-weight: 600; font-size: 1.3rem; color: #b71c1c;">Cannot Save: Shipped Lines</span>
						</div>
						<div v-for="blocked in blockedLines" :key="'blocked-' + blocked.lineItemId"
							style="display: flex; align-items: flex-start; padding: 7px 14px; border-bottom: 1px solid #ffcdd2;">
							<v-icon x-small color="red darken-1" style="margin-right: 8px; margin-top: 2px; flex-shrink: 0;">mdi-alert</v-icon>
							<div style="flex: 1; font-size: 1.2rem; color: #444;">
								Line {{ blocked.lineNumber }} (<b>{{ blocked.styleCode }}</b>) has shipped
								<template v-if="blocked.pickTicketId"> on Pick Ticket #{{ blocked.pickTicketId }}</template>
								and cannot be {{ blocked.kind === 'removed' ? 'removed' : 'changed' }}.
								Unship the pick ticket first, then make this change.
							</div>
						</div>
					</div>

					<!-- Each item is a self-contained impact card -->

					<!-- Header-level changes (S&H, tax, contact, etc.) -->
					<div v-if="headerFieldChanges().length > 0"
						style="border: 1px solid #e0e0e0; border-radius: 4px; overflow: hidden; margin-bottom: 12px;">
						<div style="padding: 10px 14px; background: #f3e5f5; border-bottom: 1px solid #e0e0e0; display: flex; align-items: center; gap: 8px;">
							<v-icon small color="purple darken-1">mdi-file-document-edit-outline</v-icon>
							<span style="font-weight: 600; font-size: 1.3rem; color: #6a1b9a;">Order Details</span>
						</div>
						<div v-for="change in headerFieldChanges()" :key="change.action"
							style="display: flex; align-items: flex-start; padding: 7px 14px; border-bottom: 1px solid #f0f0f0;">
							<v-icon x-small color="purple" style="margin-right: 8px; margin-top: 2px; flex-shrink: 0;">mdi-arrow-right</v-icon>
							<div style="flex: 1; font-size: 1.2rem; color: #444;">
								<span style="font-weight: 600; color: #6a1b9a;">{{ change.action }}:</span>
								<span style="margin-left: 4px;" v-html="displayChangeText(change.details)"></span>
							</div>
						</div>
					</div>

					<!-- Removed Items -->
					<div v-for="item in changesSummary.removed" :key="'rm-' + item.lineItemId"
						style="border: 1px solid #e0e0e0; border-radius: 4px; overflow: hidden; margin-bottom: 12px;">
						<div style="padding: 10px 14px; background: #ffebee; border-bottom: 1px solid #e0e0e0; display: flex; align-items: center; gap: 8px;">
							<v-icon small color="red darken-1">mdi-minus-circle</v-icon>
							<span style="font-weight: 600; font-size: 1.3rem; color: #c62828;">{{ item.styleCode }}</span>
							<span style="color: #666; font-size: 1.25rem;"> &mdash; {{ item.description }}</span>
						</div>
						<div style="padding: 0;">
							<div v-if="item.pickTicketId"
								style="display: flex; align-items: center; padding: 7px 14px; border-bottom: 1px solid #f0f0f0;">
								<v-icon x-small color="deep-orange darken-2" style="margin-right: 10px;">mdi-ticket-outline</v-icon>
								<span style="color: #555; font-size: 1.2rem; flex: 1;">Pick Ticket #{{ item.pickTicketId }}</span>
								<v-chip x-small color="red lighten-4" text-color="#c62828"
									style="font-weight: 600; height: 20px;"><v-icon x-small left color="red darken-2" style="margin-right: 2px;">mdi-close-circle</v-icon>removed</v-chip>
							</div>
							<v-tooltip right v-for="po in (item.cancelledPOs || [])" :key="'cancel-' + po">
								<template v-slot:activator="{ on }">
									<div v-on="on"
										style="display: flex; align-items: center; padding: 7px 14px; border-bottom: 1px solid #f0f0f0; cursor: default;">
										<v-icon x-small color="red darken-2" style="margin-right: 10px;">mdi-clipboard-text-outline</v-icon>
										<span style="color: #555; font-size: 1.2rem; flex: 1;">PO {{ po }}</span>
										<v-chip x-small color="red lighten-4" text-color="#b71c1c"
											style="font-weight: 600; height: 20px;"><v-icon x-small left color="red darken-3" style="margin-right: 2px;">mdi-cancel</v-icon>cancelled</v-chip>
									</div>
								</template>
								<span>All line items for this PO have been removed from the order</span>
							</v-tooltip>
							<v-tooltip right v-for="po in (item.updatedPOs || [])" :key="'update-' + po">
								<template v-slot:activator="{ on }">
									<div v-on="on"
										style="display: flex; align-items: center; padding: 7px 14px; border-bottom: 1px solid #f0f0f0; cursor: default;">
										<v-icon x-small color="orange darken-2" style="margin-right: 10px;">mdi-clipboard-text-outline</v-icon>
										<span style="color: #555; font-size: 1.2rem; flex: 1;">PO {{ po }}</span>
										<v-chip x-small color="orange lighten-4" text-color="#e65100"
											style="font-weight: 600; height: 20px;"><v-icon x-small left color="orange darken-3" style="margin-right: 2px;">mdi-minus-circle</v-icon>removing item</v-chip>
									</div>
								</template>
								<span>This item will be removed from PO {{ po }}</span>
							</v-tooltip>
						</div>
					</div>

					<!-- Added Items -->
					<div v-for="(item, addedIndex) in changesSummary.added" :key="'add-' + addedIndex"
						style="border: 1px solid #e0e0e0; border-radius: 4px; overflow: hidden; margin-bottom: 12px;">
						<div style="padding: 10px 14px; background: #e8f5e9; border-bottom: 1px solid #e0e0e0; display: flex; align-items: center; gap: 8px;">
							<v-icon small color="green darken-1">mdi-plus-circle</v-icon>
							<span style="font-weight: 600; font-size: 1.3rem; color: #2e7d32;">{{ item.styleCode }}</span>
							<span style="color: #666; font-size: 1.25rem;"> &mdash; {{ item.description }}</span>
						</div>
						<div style="padding: 0;">
							<v-tooltip right v-for="po in getAddedItemPOs(item)" :key="'addpo-' + po">
								<template v-slot:activator="{ on }">
									<div v-on="on"
										style="display: flex; align-items: center; padding: 7px 14px; border-bottom: 1px solid #f0f0f0; cursor: default;">
										<v-icon x-small color="green darken-2" style="margin-right: 10px;">mdi-clipboard-text-outline</v-icon>
										<span style="color: #555; font-size: 1.2rem; flex: 1;">PO {{ po }}</span>
										<v-chip x-small color="green lighten-4" text-color="#2e7d32"
											style="font-weight: 600; height: 20px;"><v-icon x-small left color="green darken-2" style="margin-right: 2px;">mdi-plus-circle</v-icon>adding item</v-chip>
									</div>
								</template>
								<span>This item will be added to PO {{ po }}</span>
							</v-tooltip>
							<v-tooltip right v-if="item.willGenerateNewPO && !getAddedItemPOs(item).length">
								<template v-slot:activator="{ on }">
									<div v-on="on"
										style="display: flex; align-items: center; padding: 7px 14px; border-bottom: 1px solid #f0f0f0; cursor: default;">
										<v-icon x-small color="deep-purple darken-1" style="margin-right: 10px;">mdi-clipboard-plus-outline</v-icon>
										<span style="color: #555; font-size: 1.2rem; flex: 1;">New PO</span>
										<v-chip x-small color="deep-purple lighten-4" text-color="#4a148c"
											style="font-weight: 600; height: 20px;"><v-icon x-small left color="deep-purple darken-1" style="margin-right: 2px;">mdi-plus-circle</v-icon>will be generated</v-chip>
									</div>
								</template>
								<span>A new purchase order will be generated for this item when the order is processed</span>
							</v-tooltip>
							<div v-else-if="!getAddedItemPOs(item).length"
								style="padding: 7px 14px; color: #888; font-size: 1.2rem;">
								Will be added to the parent purchase order
							</div>
						</div>
					</div>

					<!-- Modified Items -->
					<div v-for="item in changesSummary.modified" :key="'mod-' + item.lineItemId"
						style="border: 1px solid #e0e0e0; border-radius: 4px; overflow: hidden; margin-bottom: 12px;">
						<div style="padding: 10px 14px; background: #e3f2fd; border-bottom: 1px solid #e0e0e0; display: flex; align-items: center; gap: 8px;">
							<v-icon small color="blue darken-1">mdi-pencil-circle</v-icon>
							<span style="font-weight: 600; font-size: 1.3rem; color: #1565c0;">{{ item.styleCode }}</span>
							<span style="color: #666; font-size: 1.25rem;"> &mdash; {{ item.description }}</span>
						</div>
						<div v-for="change in getFieldChangesForItem(item.lineItemId)" :key="'fc-' + item.lineItemId + change.action + change.details"
							style="display: flex; align-items: flex-start; padding: 7px 14px; border-bottom: 1px solid #f0f0f0;">
							<v-icon x-small color="blue darken-1" style="margin-right: 8px; margin-top: 2px; flex-shrink: 0;">mdi-arrow-right</v-icon>
							<div style="flex: 1; font-size: 1.2rem; color: #444;">
								<span style="font-weight: 600; color: #1565c0;">{{ change.action }}:</span>
								<span style="margin-left: 4px;" v-html="displayChangeText(change.details)"></span>
							</div>
						</div>
						<div v-if="item.affectedPOs && item.affectedPOs.length" style="padding: 0;">
							<v-tooltip right max-width="280" v-for="po in item.affectedPOs" :key="'modpo-' + po">
								<template v-slot:activator="{ on }">
									<div v-on="on"
										style="display: flex; align-items: center; padding: 7px 14px; border-bottom: 1px solid #f0f0f0; cursor: default;">
										<v-icon x-small :color="item.poWillBeCancelled ? 'red darken-2' : 'blue darken-2'" style="margin-right: 10px;">mdi-clipboard-text-outline</v-icon>
										<span style="color: #555; font-size: 1.2rem; flex: 1;">PO {{ po }}</span>
										<v-chip v-if="item.poWillBeCancelled" x-small color="red lighten-4" text-color="#b71c1c"
											style="font-weight: 600; height: 20px;"><v-icon x-small left color="red darken-3" style="margin-right: 2px;">mdi-cancel</v-icon>will be cancelled</v-chip>
										<v-chip v-else x-small color="blue lighten-4" text-color="#1565c0"
											style="font-weight: 600; height: 20px;"><v-icon x-small left color="blue darken-2" style="margin-right: 2px;">mdi-sync</v-icon>updated</v-chip>
									</div>
								</template>
								<span v-if="item.poWillBeCancelled">The new item is a stocked item fulfilled from inventory, so PO {{ po }} is no longer needed and will be cancelled</span>
								<span v-else>PO {{ po }} will be updated with the modified item details</span>
							</v-tooltip>
						</div>
						<!-- Pick ticket consequences of an item swap -->
						<v-tooltip right max-width="280" v-if="item.pickTicketDetached">
							<template v-slot:activator="{ on }">
								<div v-on="on"
									style="display: flex; align-items: center; padding: 7px 14px; border-bottom: 1px solid #f0f0f0; cursor: default;">
									<v-icon x-small color="deep-orange darken-2" style="margin-right: 10px;">mdi-ticket-outline</v-icon>
									<span style="color: #555; font-size: 1.2rem; flex: 1;">Pick Ticket #{{ item.pickTicketId }}</span>
									<v-chip x-small color="red lighten-4" text-color="#c62828"
										style="font-weight: 600; height: 20px;"><v-icon x-small left color="red darken-2" style="margin-right: 2px;">mdi-close-circle</v-icon>item removed</v-chip>
								</div>
							</template>
							<span>The changed item no longer belongs on this pick ticket. The line is taken off it, and the ticket is deleted if no other lines remain.</span>
						</v-tooltip>
						<v-tooltip right max-width="280" v-if="item.willCreatePickTicket">
							<template v-slot:activator="{ on }">
								<div v-on="on"
									style="display: flex; align-items: center; padding: 7px 14px; border-bottom: 1px solid #f0f0f0; cursor: default;">
									<v-icon x-small color="green darken-2" style="margin-right: 10px;">mdi-ticket-outline</v-icon>
									<span style="color: #555; font-size: 1.2rem; flex: 1;">New Pick Ticket</span>
									<v-chip x-small color="green lighten-4" text-color="#2e7d32"
										style="font-weight: 600; height: 20px;"><v-icon x-small left color="green darken-2" style="margin-right: 2px;">mdi-plus-circle</v-icon>will be created</v-chip>
								</div>
							</template>
							<span>Stock is available. The item will be committed from inventory and a new pick ticket will be created.</span>
						</v-tooltip>
						<v-tooltip right max-width="280" v-if="item.willBackorder">
							<template v-slot:activator="{ on }">
								<div v-on="on"
									style="display: flex; align-items: center; padding: 7px 14px; border-bottom: 1px solid #f0f0f0; cursor: default;">
									<v-icon x-small color="orange darken-3" style="margin-right: 10px;">mdi-package-variant</v-icon>
									<span style="color: #555; font-size: 1.2rem; flex: 1;">Backordered Stock Item</span>
									<v-chip x-small color="orange lighten-4" text-color="#e65100"
										style="font-weight: 600; height: 20px;"><v-icon x-small left color="orange darken-3" style="margin-right: 2px;">mdi-clock-outline</v-icon>insufficient stock</v-chip>
								</div>
							</template>
							<span>There is not enough available stock to commit this item. It will become a backordered stock item to order.</span>
						</v-tooltip>
						<v-tooltip right max-width="280" v-if="item.willCommitFromStock">
							<template v-slot:activator="{ on }">
								<div v-on="on"
									style="display: flex; align-items: center; padding: 7px 14px; border-bottom: 1px solid #f0f0f0; cursor: default;">
									<v-icon x-small color="green darken-2" style="margin-right: 10px;">mdi-ticket-outline</v-icon>
									<span style="color: #555; font-size: 1.2rem; flex: 1;">New Pick Ticket</span>
									<v-chip x-small color="green lighten-4" text-color="#2e7d32"
										style="font-weight: 600; height: 20px;"><v-icon x-small left color="green darken-2" style="margin-right: 2px;">mdi-plus-circle</v-icon>if stock available</v-chip>
								</div>
							</template>
							<span>The stocked item will be committed from available inventory. A pick ticket is created once it commits; if stock is short it becomes a backorder.</span>
						</v-tooltip>
						<v-tooltip right max-width="280" v-if="item.willGenerateNewPO">
							<template v-slot:activator="{ on }">
								<div v-on="on"
									style="display: flex; align-items: center; padding: 7px 14px; border-bottom: 1px solid #f0f0f0; cursor: default;">
									<v-icon x-small color="deep-purple darken-1" style="margin-right: 10px;">mdi-clipboard-plus-outline</v-icon>
									<span style="color: #555; font-size: 1.2rem; flex: 1;">New PO</span>
									<v-chip x-small color="deep-purple lighten-4" text-color="#4a148c"
										style="font-weight: 600; height: 20px;"><v-icon x-small left color="deep-purple darken-1" style="margin-right: 2px;">mdi-plus-circle</v-icon>will be generated</v-chip>
								</div>
							</template>
							<span>A replacement purchase order will be generated for the new item when the order is processed.</span>
						</v-tooltip>
					</div>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions style="padding: 12px 16px;">
					<v-spacer></v-spacer>
					<v-btn
						outlined
						style="margin-right: 8px;"
						@click="confirmDialog = false"
					>
						Cancel
					</v-btn>
					<!-- Disabled until the preview returns: blocked lines are unknown before then, and
						 confirming early used to let the pending Save fire a second request (#1490) -->
					<v-btn
						color="green darken-1"
						:dark="blockedLines.length === 0 && !previewLoading"
						:disabled="blockedLines.length > 0 || previewLoading"
						:loading="previewLoading"
						data-testid="confirm-update-order"
						@click="
							() => {
								this.confirmDialog = false;
								this.processOrder();
							}
						"
					>
						Save &amp; Update Order
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<!-- Cancel Order confirmation dialog commented out - client says they will never need to cancel an order
		<v-dialog
			v-if="confirmCancelOrderDialog"
			v-model="confirmCancelOrderDialog"
			persistent
			width="auto"
		>
			<v-card>
				<v-card-title class="text-h4 mb-2">
					Are you sure you want to cancel order #{{ orderData.orderNumber }}?
				</v-card-title>
				<v-card-text class="cancel-dialog-content">
					<ul>
						<li>All related POs will be canceled.</li>
						<li>Committed Inventory will de-commit.</li>
						<li>Shipped Items will be marked unshipped.</li>
						<li>Associated quote will also be canceled.</li>
					</ul>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						text
						@click="
							() => {
								this.confirmCancelOrderDialog = false;
							}
						"
					>
						Nevermind
					</v-btn>
					<v-btn
						color="green darken-1"
						text
						@click="
							() => {
								this.confirmCancelOrderDialog = false;
								this.handleCancelOrder(true);
							}
						"
					>
						Cancel Order
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		-->

		<template>
			<v-overlay :dark="false" :value="showModal">
				<div class="input-modal warning-modal">
					<div class="input-modal-header warning-modal-header">
						<h1 class="input-modal-header-title warning-modal-title">WARNING</h1>
						<v-btn icon @click="cancelAction">
							<v-icon v-text="'mdi-close'"></v-icon>
						</v-btn>
					</div>
					<div class="input-modal-content">
						<div class="warning-modal-message">
							<p>Item is not part of defined sublist.</p>
							<p>Would you like to add a surcharge to the order?</p>
						</div>

						<ul class="warning-modal-list">
							<li key="descr">
								<v-text-field
									outlined
									dense
									hide-details="auto"
									v-model="selectedLineItem.upChargeDescription"
									label="Description (optional)"
									placeholder="Package Upgrade"
								></v-text-field>
							</li>
							<li key="upCharge">
								<v-text-field
									outlined
									dense
									hide-details="auto"
									v-model="selectedLineItem.upCharge"
									label="Amount"
									prefix="$"
									placeholder="0.00"
								></v-text-field>
							</li>
						</ul>

						<div class="input-modal-content-actions">
							<v-btn outlined depressed @click="cancelAction">Cancel</v-btn>
							<v-btn color="primary" depressed @click="confirmAction">Use this part</v-btn>
						</div>
					</div>
				</div>
			</v-overlay>
		</template>
		</v-container>

		<SalesPayments
			v-else-if="showSalesPaymentView"
			ref="salesPayments"
			:orderNumber="orderData.orderNumber"
			:orderTotal="computedOrdertotal"
			:balance="computedBalance"
			:payments="orderData.payments"
			@updatePayments="updatePayments"
			@cancel="$router.back()"
		/>

		<SalesPrintTemplate
			v-else-if="showPrintPreview"
			:printType="printType"
			:printInfo="orderData"
			:isQuote="false"
			@cancel="$router.back()"
		/>

			<PickTicketPrintTemplate
			v-else-if="showPickTicketPrintPreview"
			:orderId="orderData.salesOrderId"
			:pickTicketIds="pickTicketIds"
			@cancel="$router.back()"
		/>

		<POPrintTemplate
			v-else-if="showPOPrintPreview"
			@cancel="$router.back()"
			:purchaseOrderIds="purchaseOrderIds"
			:customer="orderData.customer"
			:shippingMethodId="orderData.shippingMethodId"
		/>

		<PackingSlipPrintTemplate
			v-else-if="showPackingSlipPrintPreview"
			@cancel="$router.back()"
			:purchaseOrderIds="purchaseOrderIds"
			:customer="orderData.customer"
			:shippingMethodId="orderData.shippingMethodId"
		/>

		<OrderStatusPrint
			v-else-if="showStatusPrintView"
			:order="orderData"
			:shippingAddress="
				computedShipToAddr && computedShipToAddr.length > 0 ? computedShipToAddr[0] : {}
			"
			:billingAddress="
				computedBillToAddr && computedBillToAddr.length > 0 ? computedBillToAddr[0] : {}
			"
			:contact="
				contacts && contacts.length > 0
					? contacts.find((contact) => contact.contactId == orderData.contactId)
					: {}
			"
			:hardRefresh="hardRefreshKey"
			@cancel="$router.push(`${basePath}/${orderData.salesOrderId}`)"
			@print="renderPrintOrder"
			@printPickTicket="
				(id) => {
					pickTicketId = id.toString();
					$router.push({
						path: `${basePath}/${this.orderData.salesOrderId}/pick-ticket-print`,
						query: { pickTicketIds: pickTicketId },
					});
				}
			"
			@printPurchaseOrders="
				(ids) => {
					$router.push({
						path: `${basePath}/${this.orderData.salesOrderId}/po-print`,
						query: { purchaseOrderIds: ids.join(',') },
					});
				}
			"
			@printPackingSlips="
				(ids) => {
					$router.push({
						path: `${basePath}/${this.orderData.salesOrderId}/packing-slip-print`,
						query: { purchaseOrderIds: ids.join(',') },
					});
				}
			"
		/>

		<!-- Unsaved changes navigation warning dialog -->
		<ConfirmNavigationDialog
			:visible="showUnsavedChangesDialog"
			:loading="savingBeforeLeave"
			@stay="handleNavigationStay"
			@leave="handleNavigationLeave"
			@save-and-leave="handleNavigationSaveAndLeave"
		/>
		<ActivityHistoryDialog
			v-model="showAuditHistory"
			:quoteId="orderData.quoteId"
			:orderId="orderData.salesOrderId"
			:quoteNumber="orderData.quoteNumber"
			:orderNumber="orderData.orderNumber"
		/>
	</div>
</template>

<script>
import gql from "graphql-tag";
import * as signalR from "@microsoft/signalr";
import DateFormatting from "@/mixins/DateFormatting";
import RateFormatting from "@/mixins/RateFormatting";
import UnsavedChangesGuard from "@/mixins/UnsavedChangesGuard";
import queries from "../../gql/queries";
import SalesEntryTable from "@/components/SalesOrders/SalesEntryTable.vue";
import SalesPayments from "@/components/SalesOrders/SalesPayments.vue";
import OrderStatusPrint from "@/components/SalesOrders/OrderStatusPrint.vue";
import SalesPrintTemplate from "@/components/SalesOrders/SalesPrintTemplate.vue";
import ConfirmNavigationDialog from "@/components/ConfirmNavigationDialog.vue";
import ActivityHistoryDialog from "@/components/SalesOrders/ActivityHistoryDialog.vue";
// ProcessingPurchaseOrdersStatus — used in OrderStatusPrint, not needed in OrderView dialog
import PickTicketPrintTemplate from "@/components/PickTicketPrintTemplateOptimized.vue";
import POPrintTemplate from "@/components/Purchasing/POPrintTemplate.vue";
import PackingSlipPrintTemplate from "@/components/Purchasing/PackingSlipPrintTemplate.vue";
import { GET_TAX_RATE } from "@/gql/settings";
import { TAX_TYPES } from "@/helpers/constant";
import { fetchItemSizeColorData } from "@/helpers/itemSizeColorData";
import { renderAddress } from "@/helpers";
import { getTotalPrice } from "@/helpers/PricingCalculator";
import { hasPermission, SystemPermissions } from "@/models/User";
import { hasValidColorSelections } from "../../DataTypes";
const request = require("request");

export default {
	name: "OrderView",
	mixins: [DateFormatting, RateFormatting, UnsavedChangesGuard],
	props: {
		order: {
			type: Object,
			default() {
				return {
					salesOrderId: null,
				};
			},
		},
		pickTicketIds: {
			type: Array,
			default: () => [],
		},
		purchaseOrderIds: {
			type: Array,
			default: () => [],
		},
		isSampleOrder: {
			type: Boolean,
			default: false,
		},
	},
	components: {
		SalesEntryTable,
		SalesPayments,
		OrderStatusPrint,
		SalesPrintTemplate,
		PickTicketPrintTemplate,
		POPrintTemplate,
		PackingSlipPrintTemplate,
		ConfirmNavigationDialog,
		ActivityHistoryDialog,
	},
	data() {
		return {
			// Placeholder item ID for draft line items
			PLACEHOLDER_ITEM_ID: -1,
			canUpdate: false,
			showAuditHistory: false,
			loadingTableData: false,
			processConfirmation: false,
			processError: false,
			isSaving: false,
			orderData: {
				salesOrderId: null,
				status: "PENDING",
				organization: "",
				customerId: null,
				contactId: null,
				customerNumber: null,
				quoteNumber: null,
				orderNumber: null, //auto generated?
				schoolPo: "",
				billToId: null,
				shipToId: null,
				shippingMethodId: null,
				paymentTermsId: null,
				processDate: "",
				orderDate: "",
				salesRepId: null,
				referenceNumber: null,
				attribution: null,
				salesTaxId: null,
				orderTotal: 0.0,
				balance: 0.0,
				shippingAndHandling: 0.0,
				shippingAndHandlingDiscount: 0.0,
				payments: [],
				items: [],
				notes: [],
				// pass these to print page
				printPrices: {},
				letterPositions: [],
				salesReps: [],
				paymentMethods: [],
				paymentTerms: [],
				shippingMethods: [],
			},
			showNoteDropdown: false,
			noteData: {
				noteId: null,
				noteType: "USER",
				noteDate: "",
				text: "",
				createdBy: "",
			},
			showOrderDate: false,
			formattedOrderDate: "",
			addresses: [],
			addressUsageMap: {},
			contacts: [],
			taxTypes: TAX_TYPES,
			shippingMethods: [],
			paymentTerms: [],
			salesReps: [],
			attribuitions: [
				{ text: "NEW", attributionId: 1 },
				{ text: "REORDER", attributionId: 2 },
				{ text: "DEALER", attributionId: 3 },
				{ text: "REP", attributionId: 4 },
				{ text: "E-COMMISSION", attributionId: 5 },
				{ text: "OUTSIDE REP", attributionId: 6 },
				{ text: "WEB PAGE", attributionId: 7 },
				{ text: "UNKNOWN", attributionId: 8 },
				{ text: "RETURN", attributionId: 9 },
			],
			printType: "INVOICE",
			computedTaxRate: 0,
			computedSubtotal: 0,
			computedTableHeight: 350,
			savedShippingHandling: -1,
			shippingAndHandlingManualOverride: false,
			taxRateManualOverride: false,
			taxRateEditMode: false,
			isCalculatingShipping: false,
			originalItemCount: -1,
			processingOrders: [],
			confirmDialog: false,
			originalOrder: {},
			updatedOrder: {},
			posToUpdate: [],
			orphanedPoIds: new Set(),
			changesSummary: { added: [], removed: [], modified: [] },
			fieldChanges: [],
			blockedLines: [],
			previewLoading: false,
			checkingForUpdates: false,
			originalItemDetails: new Map(),
			pickTicketId: 0,
			// purchaseOrderIds: [],
			confirmCancelOrderDialog: false,
			hardRefreshKey: 0,
				signalRDebounceTimer: null,
			taxRateCache: {},
			showModal: false,
			selectedLineItem: {
				upCharge: null,
				upChargeDescription: "",
			},
			resolve: null,
			reject: null,
			showCloneDialog: false,
			cloneLoading: false,
			quoteLineItemCount: null,
			isRestoring: false,
			showRestoreDialog: false,
			poRepairChanges: [],
			isRepairingPoNumbers: false,
			showPoRepairDialog: false,
			cloneOptions: {
				copySizes: true,
				copySpecialSizes: true,
				copyColors: true,
				copyNotes: true,
			},
			isLoaded: false,
		};
	},
	apollo: {
		salesReps: {
			query: queries.LIST_SALES_REPS,
			variables: {
				take: 200,
				offset: 0,
			},
			fetchPolicy: "no-cache",
			update: (data) => data.salesReps.items,
		},
		paymentTerms: {
			query: queries.GET_PAYMENT_TERMS,
			update: (data) => data.paymentTerms.items,
		},
		paymentMethods: {
			query() {
				return gql`
					query {
						paymentMethods(take: 500) {
							items {
								paymentMethodId
								paymentMethodName
							}
						}
					}
				`;
			},
			update: (data) => data.paymentMethods.items,
		},
		shippingMethods: {
			query: queries.GET_SHIPPING_METHODS,
			update: (data) => data.shippingMethods.items,
		},
		shippingMethodCalculations: {
			query() {
				return gql`
					query {
						shippingMethodCalculations(take: 201) {
							items {
								shippingMethodCalculationId
								rangeStart
								rangeEnd
								ground
								threeDay
								twoDay
								overnight
								sequence
							}
						}
					}
				`;
			},
			update: (data) => data.shippingMethodCalculations.items,
		},
		letterPositions: {
			query() {
				return gql`
					query {
						letterPosition(take: 500) {
							items {
								letterPositionId
								code
								description
							}
						}
					}
				`;
			},
			update: (data) => data.letterPosition.items,
		},
	},
	watch: {
		// Remove the automatic watcher - we'll handle manual detection differently
		"noteData.noteDate"(value) {
			this.formattedNoteDate = this.formatDate(value);
		},
		"orderData.orderDate"(value) {
			this.formattedOrderDate = this.formatDate(value);
		},
		orderData: {
			handler() {
				this.calculateTableHeight();
			},
			deep: true,
		},
		primaryView(newVal) {
			if (newVal) {
				this.calculateTableHeight();
			}
		},
		computedSubtotal(newValue, oldValue) {
			// Recalculate S&H when subtotal changes (unless manually overridden)
			if (newValue !== oldValue && !this.shippingAndHandlingManualOverride) {
				// Reset savedShippingHandling to force recalculation
				this.savedShippingHandling = -1;
				this.calculateShippingAndHandling();
			}
		},
		computedBalance() {
			this.setPricesForPrint();
			this.setOrderMetadata();
		},
		async showSalesPaymentView(newVal) {
			// Refetch payments when opening the payments view
			if (newVal && this.orderData.salesOrderId) {
				await this.refreshPayments();
			}
		},
		async hardRefreshKey() {
			await this.init();
		},
	},
	methods: {
		renderAddress,
		formatAddressOption(addr) {
			const contactName = addr.contact
				? `${addr.contact.firstName} ${addr.contact.lastName}`.trim()
				: '';
			const addrText = renderAddress(addr);
			return contactName ? `${contactName}: ${addrText}` : addrText;
		},
		// <security>
		canUpdateOrder() {
			const user = this.$store.getters.userInfo;
			if (hasPermission(user, SystemPermissions.SalesOrders_Order_Update)) {
				return true;
			}
			return user.isAdmin;
		},
		canOverrideShippingAndHandling() {
			const user = this.$store.getters.userInfo;
			if (hasPermission(user, SystemPermissions.SalesOrders_Order_OverrideShippingAndHandling)) {
				return true;
			}
			return user.isAdmin;
		},
		canCancelOrder() {
			const user = this.$store.getters.userInfo;
			if (hasPermission(user, SystemPermissions.SalesOrders_Order_Cancel)) {
				return true;
			}
			return user.isAdmin;
		},
		canProcessOrder() {
			const user = this.$store.getters.userInfo;
			if (hasPermission(user, SystemPermissions.SalesOrders_Order_Process)) {
				return true;
			}
			return user.isAdmin;
		},
		canUseNotes() {
			const user = this.$store.getters.userInfo;
			if (hasPermission(user, SystemPermissions.SalesOrders_Order_Notes_ALL)) {
				return true;
			}
			return user.isAdmin;
		},
		canUsePayments() {
			const user = this.$store.getters.userInfo;
			if (hasPermission(user, SystemPermissions.SalesOrders_Order_Payments_ALL)) {
				return true;
			}
			return user.isAdmin;
		},
		// </security>

		setOrderMetadata() {
			this.orderData.salesReps = this.salesReps;
			this.orderData.paymentMethods = this.paymentMethods;
			this.orderData.paymentTerms = this.paymentTerms;
			this.orderData.shippingMethods = this.shippingMethods;
		},
		async getProcessingPurchaseOrders(salesOrderId) {
			var r = await this.$http.get(`/api/orders/${salesOrderId}/purchase-orders`);
			if (r.data && r.data.data) {
				this.processingOrders = r.data.data;
			}
		},

		debouncedSignalRRefresh() {
			if (this.signalRDebounceTimer) {
				clearTimeout(this.signalRDebounceTimer);
			}
			this.signalRDebounceTimer = setTimeout(() => {
				this.signalRDebounceTimer = null;

				if (this.orderData.salesOrderId) {
					this.getProcessingPurchaseOrders(this.orderData.salesOrderId);

					this.$http.get(`/api/orders/${this.orderData.salesOrderId}/status`).then((res) => {
						if (res.data?.status) {
							this.orderData.status = res.data.status === "InProcess" ? "IN PROCESS" : res.data.status.toUpperCase();
						}
					}).catch(() => {});
				}

				if (this.showStatusPrintView) {
					this.hardRefreshKey++;
				}
			}, 2000);
		},

		async updateOrderItems(items) {
			this.computedSubtotal = getTotalPrice(items, 0).toFixed(2);
			this.updatedOrder = await this.setupSalesOrder();
		},

		/**
		 * Returns the state that should be tracked for unsaved changes
		 * Required by UnsavedChangesGuard mixin
		 */
		getTrackableState() {
			return {
				orderData: {
					salesOrderId: this.orderData.salesOrderId,
					customerId: this.orderData.customerId,
					contactId: this.orderData.contactId,
					status: this.orderData.status,
					orderDate: this.orderData.orderDate,
					processDate: this.orderData.processDate,
					shippingMethodId: this.orderData.shippingMethodId,
					paymentMethodId: this.orderData.paymentMethodId,
					paymentTermsId: this.orderData.paymentTermsId,
					salesRepId: this.orderData.salesRepId,
					billToId: this.orderData.billToId,
					shipToId: this.orderData.shipToId,
					attribution: this.orderData.attribution,
					schoolPo: this.orderData.schoolPo,
					referenceNumber: this.orderData.referenceNumber,
					items: this.orderData.items,
					payments: this.orderData.payments,
					notes: this.orderData.notes,
				},
				shippingAndHandling: this.shippingAndHandling,
				shippingAndHandlingDiscount: this.shippingAndHandlingDiscount,
				shippingAndHandlingManualOverride: this.shippingAndHandlingManualOverride,
			};
		},

		async saveBeforeLeave() {
			await this.saveOrder();
		},

		renderStatus(statusId) {
			let status = {
				label: "",
				color: "",
			};
			switch (statusId) {
				case "SHIPPED":
					status.label = "Shipped";
					status.color = "table-status-green";
					break;
				case "CANCELED":
				case "CANCELLED":
					status.label = "Canceled";
					status.color = "table-status-red";
					break;
				case "PENDING":
					status.label = "Pending Approval";
					status.color = "table-status-gray";
					break;
				default:
					status.label = "In Process";
					status.color = "table-status-orange";
			}

			return status;
		},

		renderStatusColor(statusLabel) {
			let statusColor;
			switch (statusLabel) {
				case "INCOMPLETE":
					statusColor = "table-status-orange";
					break;
				case "FINAL_CHECK":
					statusColor = "table-status-light-blue";
					break;
				case "CANCELED":
				case "CANCELLED":
					statusColor = "table-status-red";
					break;
				case "ORDERED":
					statusColor = "table-status-green";
					break;
				case "PENDING":
					statusColor = "table-status-gray";
					break;
				case "IN PROCESS":
					statusColor = "table-status-orange";
					break;
				case "SHIPPED":
					statusColor = "table-status-green";
					break;
				default:
					statusColor = "";
			}

			return statusColor;
		},

		renderPrintOrder(printType) {
			this.printType = printType;
			this.$router.push(`${this.basePath}/${this.orderData.salesOrderId}/print`);
		},

		async updatePayments(paymentsArr) {
			if (this._savingPayments) return;
			this._savingPayments = true;

			//add the passed in payments to the quote
			this.orderData.payments = paymentsArr;

			//reset payment view state
			this.$router.push(`${this.basePath}/${this.orderData.salesOrderId}`);

			try {
				//if a quoteId exists in data save the payments
				let paymentSaveSuccess = true;
				if (this.orderData.quoteId) {
					paymentSaveSuccess = await this.saveOrderPayments(this.orderData.quoteId);
				}

				// Only save order if payments saved successfully
				if (paymentSaveSuccess) {
					this.saveOrder();
				}
			} finally {
				this._savingPayments = false;
			}
		},

		newNote() {
			this.showNoteDropdown = true;
			this.noteData = {
				noteId: null,
				noteType: "USER",
				noteDate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
					.toISOString()
					.substr(0, 10),
				note: "",
				createdBy: this.$store.getters.userInfo.username || this.$store.getters.userInfo.name,
				createdByUser: this.$store.getters.userInfo.username || this.$store.getters.userInfo.name,
			};
		},

		saveNote() {
			//add current active note to order notes
			this.noteData.noteDate = `${this.noteData.noteDate} ${new Date().toLocaleTimeString()}`;
			this.orderData.notes.push(this.noteData);

			this.showNoteDropdown = false;

			if (this.orderData.quoteId) {
				this.saveOrderNotes(this.orderData.quoteId);
			} else {
				this.saveOrder();
			}
		},

		async getUserName(id) {
			try {
				const response = await this.$apollo.query({
					query: gql`
						query GetUserName($userId: Int!) {
							userNameById(userId: $userId) {
								fullName
								username
							}
						}
					`,
					variables: {
						userId: id,
					},
					fetchPolicy: "no-cache",
				});

				const user = response.data.userNameById;
				return user?.fullName || user?.username || "...";
			} catch (error) {
				console.error("Error fetching user:", error);
				return "...";
			}
		},

		async fetchAddressUsage(customerId) {
			try {
				const res = await this.$apollo.query({
					query: gql`query {
						addressUsage(customerId: ${customerId}) {
							addressId
							lastUsedAsBillTo
							lastUsedAsShipTo
						}
					}`,
					fetchPolicy: "no-cache",
				});
				const usageMap = {};
				if (res.data.addressUsage) {
					for (const item of res.data.addressUsage) {
						usageMap[item.addressId] = {
							lastUsedAsBillTo: item.lastUsedAsBillTo,
							lastUsedAsShipTo: item.lastUsedAsShipTo,
						};
					}
				}
				this.addressUsageMap = usageMap;
			} catch (error) {
				console.log("Error fetching address usage:", error);
			}
		},

		async getOrderInfo(orderId) {
			this.loadingTableData = true;
			try {
				//create gql filter request to get orderData by id
				console.log("getting order data...", orderId);

				const res = await this.$apollo.query({
					query: queries.GET_SALES_ORDER,
					variables: {
						id: orderId,
					},
					fetchPolicy: "no-cache",
				});

				const order = res.data.salesOrderById;
				this.savedShippingHandling = order.shippingAndHandling;
				this.shippingAndHandlingManualOverride = order.shippingAndHandlingManualOverride || false;
				this.taxRateManualOverride = order.taxRateManualOverride || false;
				this.taxRateEditMode = this.taxRateManualOverride; // Enable edit mode if already overridden

				// Preserve existing items during reload to prevent race condition where
				// navigating away before getOrderItems completes could save empty items
				const previousItems = this.orderData.items || [];

				this.orderData = {
					...order,
					salesOrderId: order.salesOrderId,
					organization: order.customer.customer.organization,
					createdAt: order.createdAt.split("T").shift(),
					billToId: order.customer.billTo,
					shipToId: order.customer.shipTo,
					contactId: order.customer.contactId,
					salesTaxId: order.customer.customer.salesTaxId ?? 0,
					customerId: order.customer.customer.customerId,
					customerNumber: order.customer.customer.customerNumber,
					quote: order.quote, // Preserve entire quote object for payment/note operations
					quoteId: order.quote?.quoteId, // Extract quoteId to top level for easy access
					quoteNumber: order.quote.quoteNumber,
					items: previousItems,
					notes: await Promise.all(
						order.quote.notes.map(async (note) => ({
							...note,
							author: note.createdBy,
							createdByUser: await this.getUserName(note.createdBy),
						}))
					),
					payments: order.quote.payments ? order.quote.payments : [],
					orderDate: order.orderDate.split("T").shift(),
					shippingAndHandling: order.shippingAndHandling,
					shippingAndHandlingDiscount: order.shippingAndHandlingDiscount,
					balance: order.balance,
				};

				//set customer addresses and contacts using query results
				this.addresses = order.customer.customer.addresses;
				this.contacts = order.customer.customer.contacts;

				// Fetch address usage data (non-blocking)
				this.fetchAddressUsage(order.customer.customer.customerId);

				if (order.status === "IN_PROCESS") {
					this.orderData.status = "IN PROCESS";
				}

				await this.getOrderItems(orderId);
				this.fetchQuoteLineItemCount(order.quote?.quoteId);
				this.fetchPoRepairPreview(orderId);
				this.$nextTick(async () => {
					// For shipped, cancelled, or in-process orders, or manually overridden rates, use the stored tax rate
					// This prevents tax rate changes (e.g., from uploading a new Zip Tax Rate file) from affecting orders that have already been finalized
					if (order.status === "SHIPPED" || order.status === "CANCELLED" || order.status === "IN_PROCESS" || this.taxRateManualOverride) {
						this.computedTaxRate = order.taxRate || 0;
					} else {
						await this.getTaxRate(this.computedZipcodeState[0], this.computedZipcodeState[1]);
					}
					// Capture initial state after all order data is loaded
					this.captureInitialState();
				});
			} catch (error) {
				console.log(error);
				this.loadingTableData = false;
			}
		},

		async refreshPayments() {
			try {
				const res = await this.$apollo.query({
					query: queries.GET_SALES_ORDER,
					variables: {
						id: this.orderData.salesOrderId,
					},
					fetchPolicy: "no-cache",
				});

				const order = res.data.salesOrderById;
				// Update only the payments and balance
				this.orderData.payments = order.quote.payments ? order.quote.payments : [];
				this.orderData.balance = order.balance;
			} catch (error) {
				console.error("Error refreshing payments:", error);
			}
		},

		async getOrderItems(orderId) {
			this.loadingTableData = true;
			try {
				const res = await this.$http.get(`/api/orders/${orderId}/lineItems`);
				const orderItems = await this.processItemsRecursively(res.data.lineItems);
				this.orderData.items = orderItems;
				this.originalItemCount = orderItems.length;
				this.computedSubtotal = getTotalPrice(orderItems, 0).toFixed(2);
				this.setPricesForPrint();
				this.loadingTableData = false;
			} catch (error) {
				console.log(error);
				this.loadingTableData = false;
			}
		},

		async fetchQuoteLineItemCount(quoteId) {
			if (!quoteId) return;
			try {
				const res = await this.$http.get(`/api/quotes/${quoteId}/lineItems`);
				this.quoteLineItemCount = res.data?.lineItems?.length ?? null;
			} catch {
				this.quoteLineItemCount = null;
			}
		},

		async fetchPoRepairPreview(orderId) {
			// Admin-only recovery data (#1448); skip the call entirely for non-admins.
			if (!orderId || !this.$store.getters.userInfo?.isAdmin) return;
			try {
				const res = await this.$http.get(`/api/orders/${orderId}/po-number-repair`);
				this.poRepairChanges = res.data?.changes ?? [];
			} catch {
				this.poRepairChanges = [];
			}
		},

		async confirmRepairPoNumbers() {
			if (!this.orderData.salesOrderId) return;
			this.isRepairingPoNumbers = true;
			try {
				const res = await this.$http.post(`/api/orders/${this.orderData.salesOrderId}/po-number-repair`);
				const changes = res.data?.changes ?? [];
				this.showPoRepairDialog = false;
				this.poRepairChanges = [];
				this.$toast?.success(
					changes.length === 0
						? 'PO numbers are already correct.'
						: `Repaired ${changes.length} PO number${changes.length === 1 ? '' : 's'}.`,
					{ timeout: 10000 }
				);
				await this.init();
			} catch (error) {
				const msg = error.response?.data?.error || 'Failed to repair PO numbers.';
				this.$toast?.error(msg, { timeout: 10000 });
			} finally {
				this.isRepairingPoNumbers = false;
			}
		},

		async confirmRestoreOrderLineItems() {
			if (!this.orderData.salesOrderId) return;
			this.isRestoring = true;
			try {
				const res = await this.$http.post(`/api/orders/${this.orderData.salesOrderId}/restore-line-items`);
				const { restored, deletedPOs, deletedPickTickets } = res.data;
				this.showRestoreDialog = false;
				this.$toast?.success(
					`Restored ${restored} line items. Cleaned up ${deletedPOs} POs and ${deletedPickTickets} pick tickets. Reprocessing triggered.`,
					{ timeout: 10000 }
				);
				await this.init();
			} catch (error) {
				const msg = error.response?.data?.error || 'Failed to restore line items.';
				this.$toast?.error(msg, { timeout: 10000 });
			} finally {
				this.isRestoring = false;
			}
		},

		async processItemsRecursively(items) {
			return Promise.all(
				items.map(async (item) => {
					// Preserve package context fields before merging with inventory data
					const packageCategoryId = item.packageCategoryId;
					const subItemCategoryId = item.subItemCategoryId;

					let inventoryItem = await this.getItemSizeColorData(item);
					item = { ...item, ...inventoryItem };
					item.priceIncluded = item.includePrice;
					this.updateColorOptionsForTableData(item);

					// Aggregate color upcharges so getItemPrice() includes them in the total.
					// Without this, colorUpCharges is only set when editing via ColorSelectionMenu.
					if (item.colorSelections && item.colorSelections.length > 0) {
						item.colorUpCharges = item.colorSelections.reduce(
							(sum, cs) => sum + (cs.upCharge || 0), 0
						);
					}

					// Restore package context fields (they should not be overwritten by inventory data)
					if (packageCategoryId !== undefined) {
						item.packageCategoryId = packageCategoryId;
					}
					if (subItemCategoryId !== undefined) {
						item.subItemCategoryId = subItemCategoryId;
					}

					item.quantity = item.quantity || 0;

					if (item.lettering) {
						let letterPositionById = this.letterPositions.find(
							(s) => s.letterPositionId == item.lettering.letterPositionId
						);
						item.lettering = { ...item.lettering, ...letterPositionById };
					}

					if (item.children && item.children.length > 0) {
						item.children = await this.processItemsRecursively(item.children);
					}

					item.stockItems = item.stockedItem;

					return item;
				})
			);
		},

		async getItemSizeColorData(item) {
			try {
				// For draft items (itemId = -1), return empty object since they don't exist in the database yet
				if (this.isDraftItem(item)) {
					return {
						colorOptions: [],
						sizeChart: null,
						type: this.$systemCategories.isSubItem(item.systemCategoryId) ? "SubItem" : "Item"
					};
				}

				// The line item already carries the inventory type from the API; only fall back to the
				// category-based guess when it is absent (e.g. rows built client-side).
				const fallbackType =
					item.type || (this.$systemCategories.isSubItem(item.systemCategoryId) ? "SubItem" : "Item");
				return await fetchItemSizeColorData(this.$apollo, item, fallbackType);
			} catch (error) {
				console.error("[OrderView] Failed to load color/size data for line item", item.itemId, error);
			}
		},

		setPricesForPrint() {
			let printPrices = {
				computedSubtotal: this.computedSubtotal,
				shippingAndHandling: this.orderData.shippingAndHandling,
				shippingAndHandlingDiscount: this.orderData.shippingAndHandlingDiscount,
				computedTaxRate: this.computedTaxRate,
				computedTaxAmount: this.computedTax,
				computedOrdertotal: this.computedOrdertotal,
				computedPayments: this.computedPayments,
				computedBalance: this.computedBalance,
			};

			this.orderData.printPrices = printPrices;
		},

		updateColorOptionsForTableData(item) {
			// If the item's colorOptions property is empty or undefined, update it
			if (
				(!item.colorOptions || item.colorOptions.length === 0) &&
				item.colorSelections &&
				item.colorSelections.length > 0
			) {
				// Create a colorOption for each colorSelection
				item.colorOptions = item.colorSelections.map((selection, index) => {
					return {
						colorOptionId: index, // Using index as ID. Adjust if needed.
						name: "",
						description: "",
						position: index + 1, // Using index + 1 for position
						colorPalettes: [
							{
								name: "Default",
								description: "Default",
								colors: [
									{
										label: selection.colorName,
										description: selection.colorName,
										hexCode: selection.hexCode,
										isVisible: true,
										colorId: selection.colorId,
										isRetired: false,
										upCharge: selection.upCharge,
										isCustomColor: selection.isCustomColor || false,
									},
								],
							},
						],
					};
				});
			} else if (item.colorOptions && item.colorSelections) {
				// For each colorSelection, check if a corresponding colorOption exists
				item.colorSelections.forEach((selection) => {
					const matchingOption = item.colorOptions.find(
						(option) =>
							option.colorPalettes &&
							option.colorPalettes[0] &&
							option.colorPalettes[0].colors &&
							option.colorPalettes[0].colors.find((color) => color.colorId === selection.colorId)
					);

					// If no matching colorOption is found, add the colorSelection to the first colorOption's colors list
					if (
						!matchingOption &&
						item.colorOptions[0] &&
						item.colorOptions[0].colorPalettes &&
						item.colorOptions[0].colorPalettes[0]
					) {
						const newColor = {
							label: selection.colorName,
							description: selection.colorName,
							hexCode: selection.hexCode,
							isVisible: true,
							colorId: selection.colorId,
							isRetired: false,
							upCharge: selection.upCharge,
							isCustomColor: selection.isCustomColor || false,
						};

						// Add the new color to the first colorOption's colors list
						item.colorOptions[0].colorPalettes[0].colors.push(newColor);
					}
				});
			}

			item.colorUpCharges = item.colorSelections.reduce(
				(acc, s) => acc + (s.upCharge && s.upCharge > 0 ? s.upCharge : 0),
				0
			);
		},

		async setupSalesOrder() {
			const mergeColorSelections = (colorSelections, freeTextSelections) => {
				const merged = [...(colorSelections || [])];
				if (freeTextSelections) {
					const existingOptionIds = new Set(
						merged.filter((cs) => cs.colorOptionId).map((cs) => cs.colorOptionId)
					);
					for (const ft of freeTextSelections) {
						if (!existingOptionIds.has(ft.colorOptionId)) {
							merged.push({ colorOptionId: ft.colorOptionId, text: ft.text });
						}
					}
				}
				return merged;
			};

			let salesOrder = {
				lineItems: this.orderData.items.map((item) => {
					let itemObj = {
						itemId: item.itemId,
						lineItemId: item.lineItemId,
						packageCategoryId: item.packageCategoryId > 0 ? item.packageCategoryId : null,
						subItemCategoryId: item.subItemCategoryId > 0 ? item.subItemCategoryId : null,
						quantity: item.quantity,
						baseQuantity: item.baseQuantity,
						quantityOverride: item.quantityOverride,
						isManuallyOverridden: item.isManuallyOverridden,
						price: item.price,
						upCharge: item.upCharge,
						sizeUpCharge: item.sizeUpCharge,
						dropShip: item.dropShip,
						note: item.note,
						upChargeDescription: item.upChargeDescription,
						includePrice: item.priceIncluded || item.includePrice,
						braidPosition: item.braidPosition,
						matchPreviousPoNumber: item.matchPreviousPoNumber,
						colorSelections: mergeColorSelections(item.colorSelections, item.freeTextSelections),
						lettering: this.sanitizeLettering(item.lettering),
						sizeSelections: item.sizeSelections
							? item.sizeSelections.map((s) => {
									return { ...s, quantity: s.quantity == "" ? 0 : s.quantity };
							  })
							: [],
						specialSizeSelections: item.specialSizeSelections
							? item.specialSizeSelections.map((s) => {
									return { ...s, quantity: s.quantity == "" ? 0 : s.quantity };
							  })
							: [],
						children: item.children
							? item.children.map((child) => {
									let childObj = {
										itemId: child.itemId,
										lineItemId: child.lineItemId,
										packageCategoryId: child.packageCategoryId > 0 ? child.packageCategoryId : null,
										subItemCategoryId: child.subItemCategoryId > 0 ? child.subItemCategoryId : null,
										quantity: child.quantity,
										baseQuantity: child.baseQuantity,
										quantityOverride: child.quantityOverride,
										isManuallyOverridden: child.isManuallyOverridden,
										price: child.price,
										upCharge: child.upCharge,
										sizeUpCharge: child.sizeUpCharge,
										dropShip: child.dropShip,
										note: child.note,
										upChargeDescription: child.upChargeDescription,
										includePrice: child.priceIncluded || child.includePrice,
										braidPosition: child.braidPosition,
										matchPreviousPoNumber: child.matchPreviousPoNumber,
										colorSelections: mergeColorSelections(
											child.colorSelections,
											child.freeTextSelections
										),
										lettering: this.sanitizeLettering(child.lettering),
										sizeSelections: child.sizeSelections
											? child.sizeSelections.map((s) => {
													return {
														...s,
														quantity: s.quantity == "" ? 0 : s.quantity,
													};
											  })
											: [],
										specialSizeSelections: child.specialSizeSelections
											? child.specialSizeSelections.map((s) => {
													return { ...s, quantity: s.quantity == "" ? 0 : s.quantity };
											  })
											: [],
										children: child.children
											? child.children.map((subchild) => {
													return {
														itemId: subchild.itemId,
														lineItemId: subchild.lineItemId,
														packageCategoryId: subchild.packageCategoryId > 0 ? subchild.packageCategoryId : null,
														subItemCategoryId: subchild.subItemCategoryId > 0 ? subchild.subItemCategoryId : null,
														quantity: subchild.quantity,
														baseQuantity: subchild.baseQuantity,
														quantityOverride: subchild.quantityOverride,
														isManuallyOverridden: subchild.isManuallyOverridden,
														price: subchild.price,
														upCharge: subchild.upCharge,
														sizeUpCharge: subchild.sizeUpCharge,
														dropShip: subchild.dropShip,
														note: subchild.note,
														upChargeDescription: subchild.upChargeDescription,
														includePrice: subchild.priceIncluded || subchild.includePrice,
														braidPosition: subchild.braidPosition,
														matchPreviousPoNumber: subchild.matchPreviousPoNumber,
														colorSelections: mergeColorSelections(
															subchild.colorSelections,
															subchild.freeTextSelections
														),
														lettering: this.sanitizeLettering(subchild.lettering),
														sizeSelections: subchild.sizeSelections
															? subchild.sizeSelections.map((s) => {
																	return {
																		...s,
																		quantity: s.quantity == "" ? 0 : s.quantity,
																	};
															  })
															: [],
														specialSizeSelections: subchild.specialSizeSelections
															? subchild.specialSizeSelections.map((s) => {
																	return { ...s, quantity: s.quantity == "" ? 0 : s.quantity };
															  })
															: [],
														children: [],
													};
											  })
											: [],
									};

									return childObj;
							  })
							: [],
					};
					return itemObj;
				}),
				customerId: this.orderData.customerId,
				contactId: this.orderData.contactId,
				shippingMethodId: this.orderData.shippingMethodId,
				paymentTermsId: this.orderData.paymentTermsId,
				billToId: this.orderData.billToId,
				shipToId: this.orderData.shipToId,
				salesRepId: this.orderData.salesRepId,
				expectedOrderDate: this.orderData.expectedOrderDate,
				attribution: this.orderData.attribution,
				schoolPo: this.orderData.schoolPo,
				referenceNumber: this.orderData.referenceNumber,
				shippingAndHandling: this.orderData.shippingAndHandling,
				shippingAndHandlingDiscount: this.orderData.shippingAndHandlingDiscount,
				shippingAndHandlingManualOverride: this.shippingAndHandlingManualOverride,
				tax: this.computedTax,
				taxRate: this.computedTaxRate,
				taxRateManualOverride: this.taxRateManualOverride,
				total: this.computedOrdertotal,
				balance: this.computedBalance,
				orderDate: this.orderData.orderDate,
				processDate: this.orderData.processDate,
				status: this.orderData.status,
			};
			return salesOrder;
		},

		sanitizeLettering(lettering) {
			// Only include lettering if it has valid data
			// letterPositionId must be a positive number (not null/undefined)
			// Otherwise return null to prevent serialization errors
			if (!lettering) return null;

			if (!lettering.letterPositionId || lettering.letterPositionId <= 0) {
				return null;
			}

			// Valid lettering data - return only required fields
			return {
				letterPositionId: lettering.letterPositionId,
				text: lettering.text || ''
			};
		},

		async saveOrder() {
			this.isSaving = true;

			const canSave = this.canUpdateOrder() || this.canProcessOrder();
			if (!canSave) {
				this.isSaving = false;
				return;
			}

			// ===== PHASE 1.1: Validate draft items before save =====
			const draftItems = this.getDraftItemsList(this.orderData.items);
			if (draftItems.length > 0) {
				// Mark draft items with validation errors for visual feedback
				this.markItemsWithValidationErrors(this.orderData.items, draftItems);

			// Show clear error message with specific line numbers
			const lineNumbers = draftItems.map(d => d.lineNumber).join(', ');
			const itemWord = draftItems.length === 1 ? 'item' : 'items';
			const lineWord = draftItems.length === 1 ? 'line' : 'lines';
			this.$toast?.error(
				`Cannot save order. ${draftItems.length} blank ${itemWord} found at ${lineWord} ${lineNumbers}. ` +
				'Please select inventory items for the highlighted rows or remove them.',
				{ timeout: 15000 }
			);

				this.isSaving = false;
				return;
			}
			// ===== END PHASE 1.1 =====

			// ===== PHASE 1.1b: Validate color and size selections (ORDERS ONLY) =====
			const incompleteItems = this.validateQuoteItems(this.orderData.items);
			if (incompleteItems.length > 0) {
				this.$toast?.error(
					'Cannot save order. Some items have missing color or size selections. ' +
					'Please complete all color and size selections.',
					{ timeout: 10000 }
				);

				this.isSaving = false;
				return;
			}
			// ===== END PHASE 1.1b =====

			// ===== PHASE 1.2: Validate required fields =====
			const missingFields = this.validateRequiredFields();
			if (missingFields.length > 0) {
				const fieldLabels = missingFields.map(field => {
					const labelMap = {
						customerId: 'Customer',
						contactId: 'Contact',
						shippingMethodId: 'Shipping Method',
						paymentTermsId: 'Payment Terms',
						salesRepId: 'Sales Rep'
					};
					return labelMap[field] || field;
				});

				this.$toast?.error(
					`Cannot save order. Required fields: ${fieldLabels.join(', ')}`,
					{ timeout: 10000 }
				);

				// Highlight first missing field
				this.highlightMissingField(missingFields[0]);
				this.isSaving = false;
				return;
			}
			// ===== END PHASE 1.2 =====

			// ===== PHASE 1.3: Prevent saving empty items =====
			if (this.orderData.items.length === 0) {
				this.$toast?.error(
					'Cannot save order. Order has no line items — this may indicate the page is still loading. Please wait and try again.',
					{ timeout: 10000 }
				);
				this.isSaving = false;
				return;
			}
			// ===== END PHASE 1.3 =====

			try {
				// Clear any previous validation errors
				this.clearValidationErrors(this.orderData.items);

				let salesOrder = await this.setupSalesOrder();

				if (this.orderData.salesOrderId) {
					await this.$http.put(`/api/orders/${this.orderData.salesOrderId}`, {
						...salesOrder,
						orderId: this.orderData.orderId,
					});
					//save notes on order
					this.saveOrderNotes(this.orderData.quoteId);
				} else {
					// must have order id
					throw new Error("Order id is required");
				}

				// Display save confirmation using toast
				this.isSaving = false;
				this.$toast?.success("Order saved successfully");

				// Disable navigation warning (user explicitly saved)
				this.showNavigationWarning = false;

				// Refresh order data
				await this.init();

				// Reset initial state AFTER init reloads data so the
				// snapshot matches the refreshed state
				this.$nextTick(() => {
					this.resetInitialState();
				});
			} catch (error) {
				console.error("Order save error:", error);

				this.isSaving = false;

				// ===== PHASE 4.1: Enhanced error message handling =====
				let errorMessage = "Failed to save order. Please check all required fields.";

				if (error.response?.data?.errors) {
					// Extract and clean error messages
					const rawErrors = Object.values(error.response.data.errors)
						.flat()
						.filter(msg =>
							!msg.includes("JSON") &&
							!msg.includes("BytePositionInLine") &&
							!msg.includes("$")
						);

					if (rawErrors.length > 0) {
						// Convert technical field names to friendly labels
						const friendlyErrors = rawErrors.map(msg => {
							return msg
								.replace(/CustomerId/gi, 'Customer')
								.replace(/ContactId/gi, 'Contact')
								.replace(/ShippingMethodId/gi, 'Shipping Method')
								.replace(/PaymentTermsId/gi, 'Payment Terms')
								.replace(/SalesRepId/gi, 'Sales Rep')
								.replace(/BillToId/gi, 'Bill To Address')
								.replace(/ShipToId/gi, 'Ship To Address');
						});

						// Format as bullet list if multiple errors
						if (friendlyErrors.length > 1) {
							errorMessage = "Please fix the following errors:\n\n• " + friendlyErrors.join("\n• ");
						} else {
							errorMessage = friendlyErrors[0];
						}
					}
				} else if (error.response?.data?.message) {
					errorMessage = error.response.data.message;
				} else if (error.response?.data?.error) {
					// UpdateOrder.Failure serializes as { error } (e.g. the #1491 S&H freeze guard)
					errorMessage = error.response.data.error;
				} else if (error.message) {
					errorMessage = error.message;
				}
				// ===== END PHASE 4.1 =====

				this.$toast?.error(errorMessage, { timeout: 10000 });
			}
		},

		async saveOrderPayments(quoteId) {
			try {
				let payments = this.orderData.payments.map((payment) => {
					let paymentData = {
						...payment,
						// Map GraphQL salesPaymentId → REST API paymentId
						paymentId: payment.paymentId || payment.salesPaymentId || 0,
						quoteId: quoteId,
					};

					return paymentData;
				});

				const res = await this.$http.put(`/api/quotes/${quoteId}/payments`, payments);

				// Success — update local payment IDs with DB-assigned values
				if (res.status === 200 && Array.isArray(res.data)) {
					res.data.forEach((saved, i) => {
						if (i < this.orderData.payments.length) {
							this.orderData.payments[i].paymentId = saved.paymentId;
						}
					});
					this.$toast?.success("Payments saved successfully");
					return true; // Indicate success
				}

				return false;
			} catch (error) {
				console.error("Payment save error:", error);

				// Extract user-friendly error message
				let errorMessage = "Failed to save payments. Please check all payment fields.";

				if (error.response?.data?.errors) {
					// ASP.NET validation errors - filter out technical JSON messages
					const errors = Object.values(error.response.data.errors)
						.flat()
						.filter(msg => !msg.includes("JSON") && !msg.includes("BytePositionInLine"));

					if (errors.length > 0) {
						errorMessage = errors.join(". ");
					}
				} else if (error.response?.data?.message) {
					// Custom error message
					errorMessage = error.response.data.message;
				}

				// Show user-facing error notification
				this.$toast?.error(errorMessage);
				return false; // Indicate failure
			}
		},

		async processOrder() {
			// Validate line items before processing
			if (this.orderData.items.length === 0) {
				this.$toast?.error('Cannot process order. Order must have at least one line item.', {
					timeout: 5000,
				});
				return;
			}

			// Check for DRAFT placeholder items
			const draftItems = this.getDraftItemsList(this.orderData.items);
			if (draftItems.length > 0) {
				this.markItemsWithValidationErrors(this.orderData.items, draftItems);
			const lineNumbers = draftItems.map(d => d.lineNumber).join(', ');
			const itemWord = draftItems.length === 1 ? 'item' : 'items';
			const lineWord = draftItems.length === 1 ? 'line' : 'lines';
			this.$toast?.error(
				`Cannot process order. ${draftItems.length} blank ${itemWord} found at ${lineWord} ${lineNumbers}. ` +
				'Please select inventory items for the highlighted rows or remove them.',
				{ timeout: 15000 }
			);
			}

			// Check for missing color/size selections
			const incompleteItems = this.validateQuoteItems(this.orderData.items);
			if (incompleteItems.length > 0) {
				this.$toast?.error('Cannot process order. Some items have missing color or size selections.', {
					timeout: 8000,
				});
				return;
			}

			this.isSaving = true;
			try {
				let salesOrder = await this.setupSalesOrder();
				salesOrder.posToUpdate = this.posToUpdate;

				(salesOrder.status = "INPROCESS"),
					(salesOrder.processDate = new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
						.toISOString()
						.substr(0, 10));

				if (this.orderData.salesOrderId) {
					await this.$http.post(`/api/orders/${this.orderData.salesOrderId}/process`, {
						...salesOrder,
						orderId: this.orderData.orderId,
					});
					//save notes on order
					this.saveOrderNotes(this.orderData.quoteId);
				} else {
					// must have order id
					throw new Error("Order id is required");
				}

				// set the process date
				this.orderData.processDate = salesOrder.processDate;
				this.orderData.status = salesOrder.status;

				//display save confirmation
				this.isSaving = false;
				this.processConfirmation = true;

				setTimeout(async () => {
					this.hardRefreshKey++;
					this.processConfirmation = false;
				}, 2000);
			} catch (error) {
				console.log(error);

				this.isSaving = false;
				this.processError = true;
				setTimeout(() => {
					this.processError = false;
				}, 2000);

				// Surface the server's reason (e.g. a shipped line that can't be removed)
				// instead of only the generic "Order Failed to Process!" flash (#1490).
				const reason = error.response?.data?.error || error.response?.data?.message;
				this.$toast?.error(reason || "Failed to process order. Please reload the order and try again.", {
					timeout: 10000,
				});
			}
		},

		/**
		 * Recursively find all DRAFT placeholder items in the item tree
		 */
		getDraftItemsList(itemArr) {
			let draftItems = [];
			let lineCounter = { current: 0 };

			const findDraftsRecursive = (items) => {
				items.forEach((item) => {
					lineCounter.current++;
					const currentLineNumber = lineCounter.current;

					// Use centralized draft item detection
					if (this.isDraftItem(item)) {
						draftItems.push({
							lineNumber: currentLineNumber,
							item: item,
							styleCode: item.styleCode || '[Draft Item]',
							description: item.description || '[Placeholder - Item To Be Selected]'
						});
					}
					
					// Recursively check children
					if (item.children && item.children.length > 0) {
						findDraftsRecursive(item.children);
					}
				});
			};
			
			findDraftsRecursive(itemArr);
			return draftItems;
		},

		/**
		 * Mark items with validation errors (DRAFT items) - RECURSIVE
		 */
		markItemsWithValidationErrors(itemArr, _draftItems) {
			// Clear all validation errors first (only on initial call)
			if (arguments.length === 2) {
				this.clearValidationErrors(itemArr);
			}

			// Recursively mark all draft items at all nesting levels
			itemArr.forEach((item) => {
				// Use centralized draft item detection
				if (this.isDraftItem(item)) {
					this.$set(item, 'hasValidationError', true);
				}

				// Recursively mark children
				if (item.children && item.children.length > 0) {
					this.markItemsWithValidationErrors(item.children, null);
				}
			});
		},

		/**
		 * Clear validation errors from all items
		 */
		clearValidationErrors(itemArr) {
			itemArr.forEach((item) => {
				this.$set(item, 'hasValidationError', false);
				this.$set(item, 'hasColorError', false);
				this.$set(item, 'hasSizeError', false);

				// Recursively clear children
				if (item.children && item.children.length > 0) {
					this.clearValidationErrors(item.children);
				}
			});
		},

		/**
		 * ===== PHASE 1.3: Helper Methods =====
		 */

		/**
		 * Centralized draft item detection - use this consistently throughout the component
		 * A draft item is one that hasn't been properly selected from inventory yet
		 *
		 * @param {Object} item - Line item to check
		 * @returns {boolean} - True if item is a draft/placeholder
		 */
		isDraftItem(item) {
			if (!item) return false;

			return item.itemId === this.PLACEHOLDER_ITEM_ID ||
			       item.itemId === -1 ||
			       (item.itemId == null && !item.inventoryItemId && !item.styleCode);
		},

		/**
		 * Validate required fields based on [Positive] validation from backend
		 */
		validateRequiredFields() {
			const missingFields = [];

			// Check fields that have [Positive] validation in backend UpdateOrder.cs
			if (!this.orderData.customerId || this.orderData.customerId <= 0) {
				missingFields.push('customerId');
			}
			if (!this.orderData.contactId || this.orderData.contactId <= 0) {
				missingFields.push('contactId');
			}
			if (!this.orderData.shippingMethodId || this.orderData.shippingMethodId <= 0) {
				missingFields.push('shippingMethodId');
			}
			if (!this.orderData.paymentTermsId || this.orderData.paymentTermsId <= 0) {
				missingFields.push('paymentTermsId');
			}
			if (!this.orderData.salesRepId || this.orderData.salesRepId <= 0) {
				missingFields.push('salesRepId');
			}

			return missingFields;
		},

		/**
		 * Highlight missing field in UI (scroll to it and add visual indicator)
		 */
		highlightMissingField(fieldName) {
			// Map field names to DOM selectors or refs
			const fieldMap = {
				customerId: 'contact-select', // Customer is derived from contact in OrderView
				contactId: 'contact-select',
				shippingMethodId: 'shipping-method-select',
				paymentTermsId: 'payment-terms-select',
				salesRepId: 'sales-rep-select'
			};

			const selector = fieldMap[fieldName];
			if (selector) {
				this.$nextTick(() => {
					const element = document.querySelector(`[data-field="${selector}"]`) ||
									document.querySelector(`#${selector}`);
					if (element) {
						element.scrollIntoView({ behavior: 'smooth', block: 'center' });
						// Add temporary highlight class
						element.classList.add('validation-error-highlight');
						setTimeout(() => {
							element.classList.remove('validation-error-highlight');
						}, 3000);
					}
				});
			}
		},
		// ===== END PHASE 1.3 =====

		/**
		 * Validate color and size selections for all items
		 */
		validateQuoteItems(itemArr) {
			let itemsIncomplete = [];

			// Recursively loop through all passed in items and check if color options and size options requirements are met
			itemArr.forEach((item) => {
				let hasColorError = false;
				let hasSizeError = false;

				// Color option validations
				if (!hasValidColorSelections(item, this.$store.getters.requiresLettering(item.systemCategoryId))) {
					hasColorError = true;
				}

				// Sizing validations
				if (item.sizeChart && item.sizeChart.sizes.length > 0) {
					let total = 0;
					let quantites = [];

					// Loop through sizeData and grab each quantity array
					// sizeSelections is null (not []) when the item's quantity is covered
					// entirely by special sizes, so fall back to an empty array (#1424)
					(item.sizeSelections || []).forEach((obj) => {
						if (obj.quantity) {
							quantites = [...quantites, obj.quantity];
						}
					});

					// Loop through special sizing and grab each quantity
					if (item.specialSizeSelections && item.specialSizeSelections.length > 0) {
						item.specialSizeSelections.forEach((obj) => {
							if (obj.quantity !== null) {
								quantites.push(obj.quantity);
							}
						});
					}

					// Calculate total quantities
					total = quantites
						.filter((i) => i !== "")
						.reduce((a, b) => parseInt(a) + parseInt(b), 0);

					if (total !== parseInt(item.quantity)) {
						hasSizeError = true;
					}
				}

				// If item has validation errors, mark it and add to incomplete list
				if (hasColorError || hasSizeError) {
					this.$set(item, 'hasColorError', hasColorError);
					this.$set(item, 'hasSizeError', hasSizeError);
					itemsIncomplete.push(item);
				} else {
					// Clear error flags if validation passes
					this.$set(item, 'hasColorError', false);
					this.$set(item, 'hasSizeError', false);
				}

				// If items have children, check them for requirements
				if (item.children && item.children.length > 0) {
					itemsIncomplete = [...itemsIncomplete, ...this.validateQuoteItems(item.children)];
				}
			});

			return itemsIncomplete;
		},

		async saveOrderNotes(quoteId) {
			try {
				let notes = this.orderData.notes.map((note) => {
					let noteData = {
						...note,
						quoteId: quoteId,
					};

					return noteData;
				});

				const res = await this.$http.put(`/api/quotes/${quoteId}/notes`, notes);
				console.log(res);
			} catch (error) {
				console.log(error);
			}
		},

		async handleCloneToQuote() {
			try {
				this.cloneLoading = true;
				await this.$store.dispatch("cloneOrderToQuote", {
					orderData: this.orderData,
					options: this.cloneOptions,
				});

				// Navigate to quote view
				this.$router.push({
					path: "/sales-orders/quotes/new",
					query: {
						clonedFromOrder: this.orderData.orderNumber,
					},
				});

				this.showCloneDialog = false;
			} catch (error) {
				console.error("Error cloning order:", error);
			} finally {
				this.cloneLoading = false;
			}
		},

		canAdjustTaxRate() {
			const user = this.$store.getters.userInfo;
			return hasPermission(user, SystemPermissions.SalesOrders_Quote_AdjustTaxRate) || user.isAdmin;
		},

		enableTaxRateEdit() {
			// Enable edit mode for tax rate - user must click pencil to start editing
			this.taxRateEditMode = true;
		},

		onTaxRateInput(value) {
			const numValue = parseFloat(value) || 0;
			this.computedTaxRate = numValue;
			this.taxRateManualOverride = true;
		},

		async resetTaxRateOverride() {
			this.taxRateManualOverride = false;
			this.taxRateEditMode = false;
			await this.getTaxRate(this.computedZipcodeState[0], this.computedZipcodeState[1]);
		},

		async getTaxRate(zipCode, state) {
			if (zipCode && state) {
				const { data } = await this.$apollo.query({
					query: GET_TAX_RATE,
					variables: {
						zipCode,
						state,
					},
				});

				let combinedRate = data.zipCodeTaxRates?.items?.[0]?.combinedRate;
				if (combinedRate) {
					this.computedTaxRate = combinedRate || 0;
				} else {
					// Check cache first
					if (this.taxRateCache[zipCode]) {
						this.computedTaxRate = this.taxRateCache[zipCode];
					} else {
						try {
							const apiUrl = `https://api.api-ninjas.com/v1/salestax?zip_code=${zipCode}`;
							const response = await new Promise((resolve, reject) => {
								request.get(
									{
										url: apiUrl,
										headers: { "X-Api-Key": process.env.VUE_APP_NINJAS_KEY },
									},
									(error, response, body) => {
										if (error) {
											reject(error);
										} else if (response.statusCode != 200) {
											reject(`Error: ${response.statusCode}, ${body}`);
										} else {
											resolve(JSON.parse(body));
										}
									}
								);
							});

							if (response && response.length > 0) {
								const taxData = response[0];
								const taxRate = parseFloat(taxData.total_rate) * 100 || 0;
								this.computedTaxRate = taxRate;
								this.taxRateCache[zipCode] = taxRate; // Cache the result
							} else {
								this.computedTaxRate = 0;
							}
						} catch (error) {
							console.error("Error fetching tax rate:", error);
							this.computedTaxRate = 0;
						}
					}
				}
			} else {
				this.computedTaxRate = 0;
			}
		},

		onShippingAndHandlingInput(value) {
			// This is a manual user input
			this.orderData.shippingAndHandling = value;
			this.shippingAndHandlingManualOverride = true;
		},

		onShippingMethodChange() {
			// A processed order keeps its S&H when the method changes (#1491); an admin reprices it by hand.
			if (this.isShippingAndHandlingFrozen) return;
			this.calculateShippingAndHandling(true);
		},

		calculateShippingAndHandling(override = false) {
			// Processed orders hold their S&H (#1491). Only the explicit Recalculate button, which
			// is shown to users allowed to override, passes override=true here.
			if (this.isShippingAndHandlingFrozen && !override) {
				return this.orderData.shippingAndHandling;
			}

			// Don't calculate if manually overridden (unless explicitly requested)
			if (this.shippingAndHandlingManualOverride && !override) {
				return this.orderData.shippingAndHandling;
			}

			// Check if we have all required data
			const hasRequiredData =
				this.orderData.shippingMethodId &&
				this.shippingMethodCalculations?.length > 0 &&
				this.shippingMethods?.length > 0;

			if (!hasRequiredData) {
				// Don't reset to 0 if data is missing
				console.warn("Missing data for S&H calculation:", {
					shippingMethodId: this.orderData.shippingMethodId,
					hasCalculations: this.shippingMethodCalculations?.length > 0,
					hasMethods: this.shippingMethods?.length > 0,
				});
				return this.orderData.shippingAndHandling || 0;
			}

			let addedNewItems = this.originalItemCount != this.orderData.items.length;

			// Calculate when: new order, override requested, or items changed
			if (this.savedShippingHandling === -1 || override === true || addedNewItems) {
				const shippingCalculationGroup = this.shippingMethodCalculations?.find(
					(obj) => obj.rangeEnd >= this.computedSubtotal
				) || this.shippingMethodCalculations?.[this.shippingMethodCalculations.length - 1];
				const shippingMethodById = this.shippingMethods.find(
					(s) => s.shippingMethodId == this.orderData.shippingMethodId
				);

				//generate the appropriate shipping charge based on the shipping method and subtotal price range
				let generatedShippingAndHandling = 0;
				if (shippingCalculationGroup && shippingMethodById) {
					switch (shippingMethodById.shippingCategoryId) {
						case 1:
							generatedShippingAndHandling = shippingCalculationGroup["ground"] || 0;
							break;
						case 2:
							generatedShippingAndHandling = shippingCalculationGroup["threeDay"] || 0;
							break;
						case 3:
							generatedShippingAndHandling = shippingCalculationGroup["twoDay"] || 0;
							break;
						case 4:
							generatedShippingAndHandling = shippingCalculationGroup["overnight"] || 0;
							break;
						default:
							generatedShippingAndHandling = shippingCalculationGroup["ground"] || 0;
							break;
					}
				}

				// Set the value programmatically (not manual)
				this.orderData.shippingAndHandling = generatedShippingAndHandling;
				this.shippingAndHandlingManualOverride = false; // Reset after calc

				return generatedShippingAndHandling;
			}

			return this.savedShippingHandling;
		},

		areObjectsEqual(obj1, obj2) {
			let obj1Filtered = { ...obj1 };
			let obj2Filtered = { ...obj2 };
			delete obj1Filtered.children;
			delete obj2Filtered.children;
			// Match Previous PO # must COUNT as a change (#1461): the PO line item stores
			// a copy of it, so editing it after processing has to badge the PO for an
			// UpdatePo rewrite or reprints keep showing the stale value. Compare it
			// separately with empty-value normalization (null/undefined/"" are equal, and
			// JSON.stringify key ordering can't produce false positives).
			delete obj1Filtered.matchPreviousPoNumber;
			delete obj2Filtered.matchPreviousPoNumber;
			const sameMatchPreviousPo =
				(obj1.matchPreviousPoNumber || null) === (obj2.matchPreviousPoNumber || null);
			return sameMatchPreviousPo && JSON.stringify(obj1Filtered) === JSON.stringify(obj2Filtered);
		},

		async checkForUpdates() {
			// Refresh PO data in case background processing completed since page load
			if (this.orderData.salesOrderId) {
				await this.getProcessingPurchaseOrders(this.orderData.salesOrderId);
			}
			this.updatedOrder = await this.setupSalesOrder();

			// Recursive function to detect changes including children
			const findDeepChanges = (updated) => {
				let original = { ...this.originalOrder };
				let changes = [];

				// Check for missing line items
				let originalLineItemIds = original.lineItems.map((item) => item.lineItemId);
				let updatedLineItemIds = updated.lineItems.map((item) => item.lineItemId);
				let missingLineItemIds = originalLineItemIds.filter(
					(id) => !updatedLineItemIds.includes(id)
				);
				changes = changes.concat(missingLineItemIds);

				// Check for changes in existing line items
				updated.lineItems.forEach((updatedItem) => {
					let originalItem = original.lineItems.find(
						(item) => item.lineItemId === updatedItem.lineItemId
					);

					if (originalItem) {
						if (!this.areObjectsEqual(originalItem, updatedItem)) {
							changes.push(updatedItem.lineItemId);
						}

						// Check for changes in children
						if (originalItem.children && updatedItem.children) {
							originalItem.children.forEach((originalChild) => {
								let updatedChild = updatedItem.children.find(
									(child) => child.lineItemId === originalChild.lineItemId
								);

								if (!updatedChild || !this.areObjectsEqual(originalChild, updatedChild)) {
									changes.push(originalChild.lineItemId);
								}

								// Check for changes in sub-children
								if (originalChild.children && updatedChild && updatedChild.children) {
									originalChild.children.forEach((originalSubChild) => {
										let updatedSubChild = updatedChild.children.find(
											(child) => child.lineItemId === originalSubChild.lineItemId
										);

										if (
											!updatedSubChild ||
											!this.areObjectsEqual(originalSubChild, updatedSubChild)
										) {
											changes.push(originalSubChild.lineItemId);
											// Also flag the parent so its PO is included
											changes.push(originalChild.lineItemId);
										}
									});

									// Detect NEW or REMOVED sub-children
									const originalSubChildIds = new Set(originalChild.children.map(sc => sc.lineItemId));
									const updatedSubChildIds = new Set(updatedChild.children.map(sc => sc.lineItemId));
									const hasNewSubChildren = updatedChild.children.some(sc => !originalSubChildIds.has(sc.lineItemId));
									const hasRemovedSubChildren = originalChild.children.some(sc => !updatedSubChildIds.has(sc.lineItemId));
									if (hasNewSubChildren || hasRemovedSubChildren) {
										changes.push(originalChild.lineItemId);
										changes.push(updatedItem.lineItemId);
									}
								}
							});

							// Detect NEW or REMOVED children — include the parent's lineItemId
							// so its PO appears in the update prompt
							const originalChildIds = new Set(originalItem.children.map(c => c.lineItemId));
							const updatedChildIds = new Set(updatedItem.children.map(c => c.lineItemId));
							const hasNewChildren = updatedItem.children.some(c => !originalChildIds.has(c.lineItemId));
							const hasRemovedChildren = originalItem.children.some(c => !updatedChildIds.has(c.lineItemId));
							if (hasNewChildren || hasRemovedChildren) {
								changes.push(updatedItem.lineItemId);
							}
						}
					}
				});

				return changes;
			};

			const changedLineItems = findDeepChanges(this.updatedOrder);
			this.posToUpdate = [];

			changedLineItems.forEach((lineItemId) => {
				this.processingOrders.forEach((order) => {
					// A cancelled PO is a dead record — it can't be updated by the save, and
					// badging it in the dialog claims an action that will never happen.
					if (order.purchaseOrder?.isCancelled) return;
					if (order.lineItems.some((item) => item.lineItemId === lineItemId)) {
						if (
							!this.posToUpdate.some(
								(po) => po.purchaseOrder.purchaseOrderId === order.purchaseOrder.purchaseOrderId
							)
						) {
							this.posToUpdate.push(order);
						}
					}
				});
			});

			// Identify orphaned POs (line items removed from the order) — these will be cancelled
			const currentLineItemIds = new Set(
				this.updatedOrder.lineItems.flatMap(li => {
					const ids = [li.lineItemId];
					if (li.children) ids.push(...li.children.map(c => c.lineItemId));
					if (li.children) li.children.forEach(c => {
						if (c.children) ids.push(...c.children.map(sc => sc.lineItemId));
					});
					return ids;
				}).filter(Boolean)
			);
			// Scan ALL active POs, not just the badged ones: removing a parent line never
			// badges its children's POs (change detection is root-level), but those POs
			// are cancelled by the save all the same and the dialog must say so.
			this.orphanedPoIds = new Set(
				this.processingOrders
					.filter(po => !po.purchaseOrder?.isCancelled)
					.filter(po => po.lineItems.length > 0 && po.lineItems.every(li => !currentLineItemIds.has(li.lineItemId)))
					.map(po => po.purchaseOrder.purchaseOrderId)
			);

			// Build changes summary for the confirmation dialog
			this.changesSummary = this.buildChangesSummary(
				this.originalOrder,
				this.updatedOrder,
				this.processingOrders
			);

			// Any structural change to a processed order gets reviewed: added lines (the
			// client-side willGenerateNewPO guess can under-predict, and the authoritative
			// backend answer only arrives after the dialog opens), removed lines, item
			// swaps (even when no ACTIVE PO is badged — e.g. it was already cancelled by
			// a previous swap), and badged PO updates.
			const hasStructuralChanges =
				this.changesSummary.added.length > 0 || this.changesSummary.removed.length > 0;
			const hasItemSwaps = this.changesSummary.modified.some(item => item.itemChanged);
			// Captured locally: the dialog's confirm button resets this.confirmDialog while the
			// preview below is in flight, and returning the live flag then told trySave there
			// was nothing to review, so it fired a plain save alongside the process (#1490).
			const needsConfirmation =
				(this.posToUpdate && this.posToUpdate.length > 0) || hasStructuralChanges || hasItemSwaps;
			this.confirmDialog = needsConfirmation;

			this.fieldChanges = [];
			this.blockedLines = [];
			if (needsConfirmation && this.orderData.salesOrderId) {
				this.previewLoading = true;
				try {
					const response = await this.$http.post(
						`/api/orders/${this.orderData.salesOrderId}/preview-changes`,
						{ ...this.updatedOrder, orderId: this.orderData.salesOrderId }
					);
					this.fieldChanges = response.data?.changes || [];
					// Shipped lines the save would change or remove. The backend rejects
					// such a save outright, so the dialog blocks it up front with the
					// reason. (If this preview call fails, the backend guard still rejects.)
					this.blockedLines = response.data?.blockedLines || [];

					// Authoritative PO predictions for NEW lines — the client-side guess
					// reads stockItems/processType off UI row hydration, which is
					// unreliable for freshly added rows (e.g. a not-stocked braid
					// sub-item that generates its own Braid PO). Matched by itemId,
					// consuming each impact once so duplicate styles pair up in order.
					const addedImpacts = [...(response.data?.addedLineImpacts || [])];
					for (const entry of this.changesSummary?.added || []) {
						const idx = addedImpacts.findIndex((ai) => ai.itemId === entry.itemId);
						if (idx === -1) continue;
						entry.willGenerateNewPO = addedImpacts[idx].willGeneratePo;
						addedImpacts.splice(idx, 1);
					}

					// The backend's per-line impact preview is authoritative — it compares
					// old vs new items server-side (StockItems, active POs, receipts, ticket
					// print state), where the client-side heuristic depends on row hydration
					// that isn't guaranteed after an item swap. Overlay it onto the summary.
					for (const impact of response.data?.lineImpacts || []) {
						const entry = this.changesSummary?.modified?.find(
							(m) => m.lineItemId === impact.lineItemId
						);
						if (!entry) continue;
						entry.poWillBeCancelled = impact.poAction === 'cancel';
						// 'none' = no active PO exists; 'keep' = the PO has receipts and the
						// save leaves it untouched. Either way, no PO action occurs — drop
						// the PO rows rather than display an "updated" that won't happen.
						if (impact.poAction === 'none' || impact.poAction === 'keep') {
							entry.affectedPOs = [];
						}
						entry.pickTicketDetached = impact.pickTicketDetached;
						if (impact.pickTicketId) entry.pickTicketId = impact.pickTicketId;
						// The backend verified stock availability, so the outcome is
						// definite — suppress the uncertain client-side hedge row.
						entry.willCommitFromStock = false;
						entry.willCreatePickTicket = impact.followOn === 'pickTicket';
						entry.willBackorder = impact.followOn === 'backorder';
						entry.willGenerateNewPO = impact.followOn === 'newPo';
					}
				} catch {
					// Non-blocking — dialog shows without field-level details if preview fails
				} finally {
					this.previewLoading = false;
				}
			}

			return needsConfirmation;
		},

		snapshotItemDetails() {
			this.originalItemDetails = new Map();
			const snapshotNode = (node) => {
				if (node.lineItemId) {
					this.originalItemDetails.set(node.lineItemId, {
						styleCode: node.styleCode || node.itemOrdered?.styleCode,
						description: node.description || node.itemOrdered?.description,
						pickTicketId: node.pickTicketId,
					});
				}
				for (const child of node.children || []) {
					snapshotNode(child);
				}
			};
			for (const item of this.orderData?.items || []) {
				snapshotNode(item);
			}
		},

		buildChangesSummary(originalOrder, updatedOrder, processingOrders) {
			const flattenItems = (items) => (items || []).flatMap(li => {
				const result = [li];
				if (li.children) result.push(...flattenItems(li.children));
				return result;
			});
			const allOriginalItems = flattenItems(originalOrder.lineItems);
			const allUpdatedItems = flattenItems(updatedOrder.lineItems);

			const originalIds = new Set(allOriginalItems.map(i => i.lineItemId).filter(Boolean));
			const updatedIds = new Set(allUpdatedItems.map(i => i.lineItemId).filter(Boolean));

			// Root-level line item IDs (direct children of the order, not sub-items)
			const rootLineItemIds = new Set((updatedOrder.lineItems || []).map(li => li.lineItemId).filter(Boolean));

			// Helper to find item details — checks current items first, falls back to snapshot.
			// NEW rows have no lineItemId yet, so they must match by itemId among the other
			// unsaved rows — matching `undefined === undefined` made every added line resolve
			// to the FIRST new row's details (three added lines all displayed as one item).
			const findItemDetail = (lineItemId, itemId = null) => {
				const searchNodes = (nodes) => {
					for (const node of nodes) {
						if (lineItemId != null && node.lineItemId === lineItemId) return node;
						if (lineItemId == null && itemId != null && node.lineItemId == null && node.itemId === itemId) return node;
						if (node.children) {
							const found = searchNodes(node.children);
							if (found) return found;
						}
					}
					return null;
				};
				const fromUi = searchNodes(this.orderData?.items || []);
				if (fromUi) return fromUi;
				// Item was removed from UI — use snapshot captured at page load
				return lineItemId != null ? (this.originalItemDetails.get(lineItemId) || null) : null;
			};

			// Helper to find the nearest ancestor whose lineItemId is on a PO
			const findAncestorOnPO = (lineItemId, items) => {
				for (const item of items) {
					const found = (function search(node, ancestors) {
						if (node.lineItemId === lineItemId) return ancestors;
						for (const child of node.children || []) {
							const result = search(child, [...ancestors, node]);
							if (result) return result;
						}
						return null;
					})(item, []);
					if (found) {
						// Walk ancestors from nearest to root, return first one that has a PO
						for (let i = found.length - 1; i >= 0; i--) {
							const po = processingOrders.find(po =>
								po.lineItems.some(li => li.lineItemId === found[i].lineItemId) &&
								!this.orphanedPoIds.has(po.purchaseOrder.purchaseOrderId)
							);
							if (po) return po.purchaseOrder.purchaseOrderNumber;
						}
						return null;
					}
				}
				return null;
			};

			// Helper to find which POs reference a line item, split by cancelled vs updated
			const findAffectedPOs = (lineItemId) => {
				const directPOs = processingOrders
					.filter(po => po.lineItems.some(li => li.lineItemId === lineItemId));

				const cancelledPOs = directPOs
					.filter(po => this.orphanedPoIds.has(po.purchaseOrder.purchaseOrderId))
					.map(po => po.purchaseOrder.purchaseOrderNumber);

				const updatedPOs = directPOs
					.filter(po => !this.orphanedPoIds.has(po.purchaseOrder.purchaseOrderId))
					.map(po => po.purchaseOrder.purchaseOrderNumber);

				return { cancelledPOs, updatedPOs };
			};

			// Helper to find the parent item's PO (sub-items are included on the parent PO)
			const findParentPO = (lineItemId) => {
				// Check current items first, then fall back to original order
				// (removed items won't be in current items anymore)
				return findAncestorOnPO(lineItemId, this.orderData?.items || [])
					|| findAncestorOnPO(lineItemId, originalOrder.lineItems || []);
			};

			// Removed items
			const removed = allOriginalItems
				.filter(i => i.lineItemId && !updatedIds.has(i.lineItemId))
				.map(i => {
					const detail = findItemDetail(i.lineItemId);
					const { cancelledPOs, updatedPOs } = findAffectedPOs(i.lineItemId);
					const parentPO = findParentPO(i.lineItemId);
					if (parentPO && !updatedPOs.includes(parentPO)) {
						updatedPOs.push(parentPO);
					}
					const pickTicketId = detail?.pickTicketId;
					return {
						lineItemId: i.lineItemId,
						styleCode: detail?.styleCode || detail?.itemOrdered?.styleCode || `Item ${i.itemId}`,
						description: detail?.description || detail?.itemOrdered?.description || '',
						cancelledPOs,
						updatedPOs,
						pickTicketId,
					};
				});

			// Determine if an item will trigger new PO generation when the order is processed.
			// Mirrors the state machine rule: sub-items with a process type (and not stocked),
			// root-level not-stocked items, and items with special size selections each get their own PO.
			const willItemGenerateNewPO = (lineItemId, itemId = null) => {
				const detail = findItemDetail(lineItemId, itemId);
				if (!detail) return false;
				const hasProcessType = detail.processType && detail.processType !== 'None';
				const isNotStocked = detail.stockItems === false;
				const hasSpecialSizes = (detail.specialSizeSelections || []).some(s => s.quantity > 0);
				const isRoot = !lineItemId || rootLineItemIds.has(lineItemId);
				return hasSpecialSizes || (isNotStocked && (hasProcessType || isRoot));
			};

			// Added items
			const added = allUpdatedItems
				.filter(i => !i.lineItemId || !originalIds.has(i.lineItemId))
				.map(i => {
					const detail = findItemDetail(i.lineItemId, i.itemId) || i;
					return {
						lineItemId: i.lineItemId,
						itemId: i.itemId,
						styleCode: detail?.styleCode || detail?.itemOrdered?.styleCode || `Item ${i.itemId}`,
						description: detail?.description || detail?.itemOrdered?.description || '',
						// Client-side guess — overridden by the backend preview's
						// addedLineImpacts, whose item data is authoritative.
						willGenerateNewPO: willItemGenerateNewPO(i.lineItemId, i.itemId),
					};
				});

			// Modified items (changed but not added/removed)
			const modified = allUpdatedItems
				.filter(i => i.lineItemId && originalIds.has(i.lineItemId))
				.filter(i => {
					const orig = allOriginalItems.find(o => o.lineItemId === i.lineItemId);
					return orig && !this.areObjectsEqual(orig, i);
				})
				.map(i => {
					const detail = findItemDetail(i.lineItemId) || i;
					const { updatedPOs } = findAffectedPOs(i.lineItemId);

					// An item SWAP has bigger consequences than a detail edit, and the modal
					// must disclose them: swapping to a stocked item CANCELS the line's PO
					// (fulfilled from inventory instead), and any swap pulls the line off an
					// unprinted pick ticket it was committed onto (the ticket is deleted if
					// no other lines remain on it).
					const orig = allOriginalItems.find(o => o.lineItemId === i.lineItemId);
					const itemChanged = !!orig && orig.itemId !== i.itemId;
					const newItemIsStocked = itemChanged && detail?.stockItems === true;
					const snapshot = this.originalItemDetails.get(i.lineItemId);
					const pickTicketId = snapshot?.pickTicketId ?? detail?.pickTicketId;

					return {
						lineItemId: i.lineItemId,
						styleCode: detail?.styleCode || detail?.itemOrdered?.styleCode || `Item ${i.itemId}`,
						description: detail?.description || detail?.itemOrdered?.description || '',
						affectedPOs: updatedPOs,
						itemChanged,
						poWillBeCancelled: newItemIsStocked,
						pickTicketDetached: itemChanged && !!pickTicketId,
						pickTicketId,
						// Uncertain client-side guess — used only if the preview call fails.
						willCommitFromStock: newItemIsStocked && !willItemGenerateNewPO(i.lineItemId),
						willGenerateNewPO: newItemIsStocked && willItemGenerateNewPO(i.lineItemId),
						// Definite outcomes from the backend availability check (Vue 2 needs
						// the properties declared here for the overlay to be reactive).
						willCreatePickTicket: false,
						willBackorder: false,
					};
				});

			// Build per-PO impact summaries for non-cancelled POs
			const poImpacts = {};
			for (const item of removed) {
				for (const poNum of item.updatedPOs || []) {
					if (!poImpacts[poNum]) poImpacts[poNum] = { removing: [], adding: [] };
					poImpacts[poNum].removing.push(item.styleCode);
				}
			}
			for (const item of added) {
				// Find which POs the parent belongs to (added items will be included on parent PO)
				const parentPO = findParentPO(item.lineItemId);
				if (parentPO) {
					if (!poImpacts[parentPO]) poImpacts[parentPO] = { removing: [], adding: [] };
					poImpacts[parentPO].adding.push(item.styleCode);
				}
			}

			return { added, removed, modified, poImpacts };
		},

		getAddedItemPOs(item) {
			const poNum = this.changesSummary?.poImpacts
				? Object.keys(this.changesSummary.poImpacts).filter(po =>
					(this.changesSummary.poImpacts[po].adding || []).includes(item.styleCode)
				)
				: [];
			return poNum;
		},

		getFieldChangesForItem(lineItemId) {
			return this.fieldChanges.filter(c => c.lineItemId === lineItemId);
		},

		headerFieldChanges() {
			// Header-level changes have no lineItemId and no inventoryItemId
			return this.fieldChanges.filter(c => !c.lineItemId && !c.inventoryItemId);
		},

		displayChangeText(text) {
			if (!text) return '';
			return text.replace(/\*\*([^*]+)\*\*/g, '<b>$1</b>');
		},

		async trySave() {
			// One evaluation at a time: a double-click would otherwise run two change
			// checks and could submit the same new lines twice (#1490).
			if (this.checkingForUpdates || this.isSaving) return;
			this.checkingForUpdates = true;
			let hasUpdates;
			try {
				this.posToUpdate = [];
				hasUpdates = await this.checkForUpdates();
			} finally {
				this.checkingForUpdates = false;
			}
			if (!hasUpdates) {
				this.saveOrder();
			}
		},

		renderOrderStatus(orderStatus) {
			let status = {
				label: "",
				color: "",
			};
			switch (orderStatus) {
				case "OnOrder":
					status.label = "On Order";
					status.color = "table-status-gray";
					break;
				case "PartiallyReceived":
					status.label = "Partially Received";
					status.color = "table-status-gray";
					break;
				case "Received":
					status.label = "Received";
					status.color = "table-status-green";
					break;
				case "Cancelled":
					status.label = "Cancelled";
					status.color = "table-status-red";
					break;
				default:
					status.label = "Error";
					status.color = "table-status-orange";
			}

			return status;
		},

		async handleCancelOrder(isCancelled) {
			let orderNumber = this.orderData.orderNumber;
			const res = await this.$http.post(
				isCancelled ? `/api/orders/${orderNumber}/cancel` : `/api/orders/${orderNumber}/restore`
			);
			console.log(res);
			this.hardRefreshKey++;
			await this.init();
		},

		handleSave(resolve, reject, existing) {
			this.selectedLineItem = {
				upCharge: existing && existing.upCharge ? existing.upCharge : null,
				upChargeDescription:
					existing && existing.upChargeDescription ? existing.upChargeDescription : "",
			};
			this.showModal = true;
			this.resolve = resolve;
			this.reject = reject;
		},

		confirmAction() {
			if (this.resolve) {
				this.resolve({
					upChargeDescription: this.selectedLineItem.upChargeDescription,
					upCharge: this.selectedLineItem.upCharge,
				});
				this.showModal = false;
			}
		},
		cancelAction() {
			if (this.reject) {
				this.reject(new Error("Operation cancelled by user."));
				this.showModal = false;
			}
		},

		handleResize() {
			// Force recomputation of tableBodyHeight
			this.calculateTableHeight();
		},

		calculateTableHeight() {
			// Only calculate if we're in the primary view
			if (!this.primaryView) return;

			this.computedTableHeight = 250;
			this.$nextTick(() => {
				// Get the window height
				const windowHeight = window.innerHeight;

				// Get container heights
				const detailContainer = document.getElementById("detail-container")?.offsetHeight || 0;
				const footerContainer =
					document.getElementById("sales-footer-container")?.offsetHeight || 0;

				// Calculate available space (subtracting padding and margins)
				const availableHeight = windowHeight - detailContainer - footerContainer - 64 - 36; // 64px for header, 36px for padding

				this.computedTableHeight = Math.max(availableHeight, 200);
			});
		},

		async init() {
			//check if order prop with id is passed in and retrieve that orders data
			if (this.order.salesOrderId) {
				await this.getOrderInfo(this.order.salesOrderId);
				await this.getProcessingPurchaseOrders(this.order.salesOrderId);
				const salesOrder = await this.setupSalesOrder();
				this.originalOrder = JSON.parse(JSON.stringify(salesOrder));
				this.snapshotItemDetails();
			}

			this.setOrderMetadata();

			this.canUpdate = this.canUpdateOrder();
			this.calculateTableHeight();

			await this.$nextTick(() => {
				this.isLoaded = true;
			});
		},
	},
	computed: {
		// #1491: once processed, S&H and the S&H discount hold at their processed values.
		// Nothing recalculates them automatically; only users allowed to override may edit them.
		isShippingAndHandlingFrozen() {
			return !!this.orderData.status && this.orderData.status !== "PENDING";
		},
		shippingAndHandlingLocked() {
			return this.isShippingAndHandlingFrozen && !this.canOverrideShippingAndHandling();
		},
		shippingAndHandlingLockedMessage() {
			return "Shipping and handling is locked once an order is processed. Only an admin can change it.";
		},
		shippingAndHandlingTooltip() {
			if (this.shippingAndHandlingLocked) return "";
			if (this.shippingAndHandlingManualOverride) return "Manually overridden - Click refresh to recalculate";
			if (this.isShippingAndHandlingFrozen) return "Locked at the processed amount - Click refresh to recalculate";
			return "";
		},
		canRestoreLineItems() {
			const user = this.$store.getters.userInfo;
			if (!user?.isAdmin) return false;
			if (!this.orderData.quoteId) return false;
			const currentCount = this.orderData.items?.length ?? 0;
			if (currentCount === 0) return true;
			if (this.quoteLineItemCount !== null && currentCount < this.quoteLineItemCount) return true;
			return false;
		},
		canRepairPoNumbers() {
			const user = this.$store.getters.userInfo;
			return !!user?.isAdmin && this.poRepairChanges.length > 0;
		},
		canViewPrinterSettings() {
			const user = this.$store.getters.userInfo;
			return user?.isAdmin || hasPermission(user, SystemPermissions.Settings_Printers_ALL);
		},
		/**
		 * Returns the base path for navigation based on whether this is a sample order.
		 * Uses the prop passed from the router to maintain context.
		 */
		basePath() {
			return this.isSampleOrder ? '/sales-orders/sample-orders' : '/sales-orders/orders';
		},
		/**
		 * Reactively checks if current line items contain any sample items.
		 * Used to show/hide the Sample chip in the header in real-time.
		 */
		hasSampleItems() {
			if (!this.orderData?.items || this.orderData.items.length === 0) {
				return this.orderData?.isSampleOrder || false;
			}
			const checkItems = (items) => {
				return items.some((item) => {
					if (item.itemId && item.itemId > 0 && this.$systemCategories.isSample(item.systemCategoryId)) {
						return true;
					}
					if (item.children && item.children.length > 0) {
						return checkItems(item.children);
					}
					return false;
				});
			};
			return checkItems(this.orderData.items);
		},
		computedBillToAddr() {
			//filter out any customer addresses that are not labeled bill to or both
			return this.addresses
				.filter(
					(addr) => addr.label.toLowerCase() == "bill to" || addr.label.toLowerCase() == "both"
				)
				.map((obj) => ({
					...obj,
					text: this.formatAddressOption(obj),
					lastUsed: this.addressUsageMap[obj.addressId]?.lastUsedAsBillTo || null,
				}));
		},
		computedShipToAddr() {
			//filter out any customer addresses that are not labeled ship to or both
			return this.addresses
				.filter(
					(addr) => addr.label.toLowerCase() == "ship to" || addr.label.toLowerCase() == "both"
				)
				.map((obj) => ({
					...obj,
					text: this.formatAddressOption(obj),
					lastUsed: this.addressUsageMap[obj.addressId]?.lastUsedAsShipTo || null,
				}));
		},
		computedZipcodeState() {
			// Use Ship To address for tax calculation (tax is based on destination)
			const selectedTaxObj = this.computedShipToAddr.find(
				(el) => el.addressId == this.orderData.shipToId
			);
			const zipCode = selectedTaxObj?.postalCode;
			const state = selectedTaxObj?.state;
			// Don't recalculate tax for shipped/cancelled/in-process orders or manually overridden rates - use stored rate
			const orderStatus = this.orderData.status;
			if (orderStatus !== "SHIPPED" && orderStatus !== "CANCELLED" && orderStatus !== "IN PROCESS" && !this.taxRateManualOverride) {
				this.getTaxRate(zipCode, state);
			}
			return [zipCode, state];
		},
		computedOrdertotal() {
			let orderTotal = 0.0;
			const subtotal = parseFloat(this.computedSubtotal) || 0;
			const shippingHandling = parseFloat(this.orderData.shippingAndHandling) || 0;
			const shippingHandlingDiscount = parseFloat(this.orderData.shippingAndHandlingDiscount) || 0;
			const taxAmount = parseFloat(this.computedTax) || 0;
			orderTotal = subtotal + shippingHandling + shippingHandlingDiscount + taxAmount;

			return orderTotal.toFixed(2);
		},
		computedTax() {
			if (this.orderData.salesTaxId === 0) {
				return 0.0;
			}

			const subtotal = parseFloat(this.computedSubtotal) || 0;
			const taxRate = parseFloat(this.computedTaxRate) || 0;
			const tax = (subtotal * taxRate) / 100;

			return tax.toFixed(2);
		},
		computedPayments() {
			let payments = 0.0;

			if (this.orderData.payments && this.orderData.payments.length > 0) {
				this.orderData.payments.forEach((payment) => {
					const amount = parseFloat(payment.amount);
					if (!isNaN(amount)) {
						payments += amount;
					}
				});
			}

			return payments.toFixed(2);
		},
		computedBalance() {
			// Ensure we never return NaN
			const orderTotal = parseFloat(this.computedOrdertotal) || 0;
			const payments = parseFloat(this.computedPayments) || 0;
			const balance = orderTotal - payments;

			// Return 0 if calculation results in NaN
			if (isNaN(balance)) {
				return "0.00";
			}

			return balance.toFixed(2);
		},
		primaryView() {
			return (
				!this.showSalesPaymentView &&
				!this.showPrintPreview &&
				!this.showPickTicketPrintPreview &&
				!this.showPackingSlipPrintPreview &&
				!this.showPOPrintPreview &&
				!this.showStatusPrintView
			);
		},
		showSalesPaymentView() {
			return this.$route.path.endsWith("/payments") && this.isLoaded;
		},
		showPrintPreview() {
			return this.$route.path.endsWith("/print") && this.isLoaded;
		},
		showPickTicketPrintPreview() {
			return this.$route.path.endsWith("/pick-ticket-print") && this.isLoaded;
		},
		showPOPrintPreview() {
			return this.$route.path.endsWith("/po-print") && this.isLoaded;
		},
		showPackingSlipPrintPreview() {
			return this.$route.path.endsWith("/packing-slip-print") && this.isLoaded;
		},
		showStatusPrintView() {
			return this.$route.path.endsWith("/status") && this.isLoaded;
		},
	},
	async mounted() {
		await this.init();
		await this.$nextTick();
		this.calculateTableHeight();

		window.addEventListener("resize", this.handleResize);

		class ContinuousRetryPolicy {
			constructor(retryIntervalMs) {
				this.retryIntervalMs = retryIntervalMs;
			}

			nextRetryDelayInMilliseconds() {
				return this.retryIntervalMs;
			}
		}

		const connection = new signalR.HubConnectionBuilder()
			.withUrl("/updateHub")
			.configureLogging(signalR.LogLevel.Information)
			.withAutomaticReconnect(new ContinuousRetryPolicy(5000)) // Attempt reconnect every 5 seconds
			.build();

		connection.start().catch((err) => console.error(err.toString()));
		connection.on("BackOrderedStockUpdated", (message) => {
			console.log(`BackOrderedStockUpdated SignalR: ${message}`);
			this.debouncedSignalRRefresh();
		});

		connection.on("OrderStatusUpdateEvent", (message) => {
			console.log(`OrderStatusUpdateEvent SignalR: ${message}`);
			this.debouncedSignalRRefresh();
		});
	},
	beforeDestroy() {
		window.removeEventListener("resize", this.handleResize);
		if (this.signalRDebounceTimer) {
			clearTimeout(this.signalRDebounceTimer);
		}
	},
};
</script>

<style lang="scss" scoped>
.order {
	&-actions {
		display: flex;
		width: 100%;
		justify-content: flex-end;
		align-items: center;
		gap: 0.8rem;

		.v-btn {
			background-color: $color-white;
			border-color: $color-gray;
			text-transform: initial;

			&.kebab-btn {
				min-width: 0;
				padding: 0 0.8rem;
			}
		}
	}

	&-form {
		position: relative;
		display: block;
		background-color: $color-white;
		border: 1px solid $color-gray;
		border-radius: 3px;
		padding: 0.5rem 1.5rem;

		.row {
			margin: initial;
		}

		.form-input {
			margin: initial;
		}

		&-header {
			display: flex;
			align-items: center;

			a {
				color: $color-tertiary;
			}
		}

		&-title {
			display: inline-block;
			font-size: 2.2rem;
			font-weight: 700;
			padding-right: 1rem;
		}
		&-status {
			text-transform: uppercase; // statuses read as labels everywhere (#300)
			display: inline-block;
			border: 1px solid;
			font-size: 1.4rem;
			padding: 0.5rem 1rem;
			border: 1px solid;

			&-orange {
				border-color: $color-orange;
				color: $color-orange;
			}

			&-green {
				border-color: $color-green;
				color: $color-green;
			}
		}

		&-divider {
			display: block;
			width: calc(100% - 24px);
			height: 1px;
			margin: 1.2rem auto;
			background-color: $color-gray;
		}
	}

	&-notes {
		position: relative;
		display: inline-flex;
		flex-flow: column;
		width: 60%;
		height: 100%;
		border: 1px solid $color-gray;
		background-color: $color-white;

		&-heading {
			display: flex;
			flex-flow: row nowrap;
			align-items: center;
			width: 100%;
			height: 4.7rem;
			background-color: $color-gray-light-2;
			border-bottom: 1px solid $color-gray;
			padding: 0.5rem 1rem;
			z-index: 1;

			h2 {
				font-size: 1.4rem;
				font-weight: 700;
				text-transform: uppercase;
				margin-right: auto;
			}

			.v-btn {
				background-color: $color-white;

				&:nth-child(3) {
					margin-left: 0.8rem;
				}
			}
		}

		&-container {
			position: absolute;
			padding-top: 4.7rem; //match with heading height
			top: 0;
			bottom: 0;
			left: 0;
			right: 0;
			flex-grow: 1;
			background-color: $color-white;
			overflow-y: auto;

			&-list {
				display: flex;
				flex-flow: column nowrap;
				width: 100%;
			}

			&-note {
				display: flex;
				flex-flow: row nowrap;
				align-items: center;
				padding: 1rem 0.8rem;
				width: 100%;
				font-size: 1.4rem;
				border-bottom: 1px solid $color-gray;

				p {
					flex: 1 1 auto;
				}

				&-type {
					padding: 0.5rem 1rem;
					min-width: 12rem;
					text-align: center;
					border-radius: 25rem;
					background-color: $color-gray;
					font-weight: 700;
					font-size: 1.4rem;
					margin-right: 1rem;

					&-2 {
						background-color: $color-green;
					}
				}

				&-author {
					margin-left: 1rem;
				}
			}
		}

		&-dropdown {
			position: relative;
			display: flex;
			flex-flow: column;
			background-color: $color-white;
			height: 0%;
			border-bottom: 1px solid transparent;
			overflow: hidden;
			transition: height 0.3s ease-in-out;
			z-index: 5;

			&-active {
				height: 100%;
				box-shadow: rgba(50, 50, 93, 0.05) 0px 2px 5px -1px, rgba(0, 0, 0, 0.2) 0px 1px 3px -1px !important;
			}

			.form-input,
			.form-textarea {
				margin: 1.25rem;
			}

			.form-input {
				display: inline-flex;
				width: calc(50% - 2.5rem);
			}

			.form-textarea {
				label {
					width: 19.5%;
				}
			}

			&-author {
				display: flex;
				align-items: center;
				justify-content: flex-end;
				font-size: 1.4rem;
				margin: 1.25rem;
				margin-top: auto;

				h3 {
					font-weight: normal;
					padding-right: 0.5rem;
				}

				p {
					font-size: 1.6rem;
				}
			}
		}
	}

	&-pricing {
		display: inline-flex;
		flex-flow: column nowrap;
		width: 40%;
		text-align: right;

		.form-input {
			flex-flow: row;
			align-items: center;
			margin: 0.4rem 0;

			label {
				margin-right: 1rem;
				font-weight: 700;
			}
			.v-text-field {
				min-width: 16rem;
				text-align: right;

				&::v-deep {
					input {
						text-align: right;
						padding-right: 0.8rem;
					}
				}
			}
		}
	}

	.col {
		padding: 5px !important;
	}
}
</style>

<style lang="scss">
.to-quote {
	cursor: pointer;

	&:hover {
		color: #1264f6;
	}
}

.cancel-dialog-content {
	font-size: 2rem;
	line-height: inherit;
}

::v-deep .text--disabled {
	opacity: 0.6;
}

.manual-override {
	::v-deep .v-input__slot {
		background-color: #fff3cd !important;
	}
}

.tax-rate-edit-icon {
	padding-left: 0.5rem;
	cursor: pointer;
	margin-right: 4px;
	&:hover {
		color: #1976d2 !important;
	}
}

.tax-rate-input.number-input .v-text-field__slot::before,
.tax-rate-input.number-input .v-text-field__slot::after {
	display: none !important;
}

.order-overflow-menu.v-menu__content {
	min-width: 200px !important;
	.v-list-item {
		min-height: 44px !important;
		padding: 0 20px !important;
	}
	.v-list-item__title {
		font-size: 1.4rem !important;
	}
	.v-list-item__icon {
		margin-right: 12px !important;
	}
}
</style>

<style lang="scss" scoped>
.v-overlay {
	::v-deep {
		.v-overlay__content {
			width: 95%;
		}
	}

	&-relative {
		position: relative;
		padding: 3rem 0;
		width: 100%;
	}
}

.warning-modal {
	max-width: 55rem;

	&-title {
		font-weight: 700;
	}

	&-message {
		font-size: 1.6rem;
		font-weight: 700;
		text-align: center;
	}

	&-list {
		list-style: none;
		text-align: center;
		padding-left: 0;
		margin-top: 1rem;

		li {
			margin: 1rem 1.75rem;
		}
	}
}
</style>
